import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import { isEmpty } from 'lodash';
import { theme } from '@helloworld1812/ws-theme';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$5 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$4 = fails$5;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$4(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$3 = fails$5;
var classof = classofRaw;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$3(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var isObject$4 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$3 = isObject$4;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$3(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$3(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$3(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$3(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has$5 = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$9 = global$a;
var isObject$2 = isObject$4;

var document = global$9.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$2(document) && isObject$2(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

var DESCRIPTORS$4 = descriptors;
var fails$2 = fails$5;
var createElement = documentCreateElement;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$4 && !fails$2(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$3 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPrimitive$1 = toPrimitive$2;
var has$4 = has$5;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$3 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$4(O, P)) return createPropertyDescriptor$1(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$1 = isObject$4;

var anObject$2 = function (it) {
  if (!isObject$1(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var DESCRIPTORS$2 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$1 = anObject$2;
var toPrimitive = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$2 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPrimitive(P, true);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$1 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$4 = DESCRIPTORS$1 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$1 = {exports: {}};

var global$8 = global$a;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$3(global$8, key, value);
  } catch (error) {
    global$8[key] = value;
  } return value;
};

var global$7 = global$a;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$7[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$2 = store$2.inspectSource;

var global$6 = global$a;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$6.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$1(WeakMap$1));

var shared$1 = {exports: {}};

var store$1 = sharedStore;

(shared$1.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var postfix = Math.random();

var uid$1 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var shared = shared$1.exports;
var uid = uid$1;

var keys = shared('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$5 = global$a;
var isObject = isObject$4;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var objectHas = has$5;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var WeakMap = global$5.WeakMap;
var set, get, has$3;

var enforce = function (it) {
  return has$3(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$3 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$3 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$3,
  enforce: enforce,
  getterFor: getterFor
};

var global$4 = global$a;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var has$2 = has$5;
var setGlobal$1 = setGlobal$3;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$1.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$2(value, 'name')) createNonEnumerableProperty$1(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global$4) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$1(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});

var global$3 = global$a;

var path$1 = global$3;

var path = path$1;
var global$2 = global$a;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$1 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global$2[namespace])
    : path[namespace] && path[namespace][method] || global$2[namespace] && global$2[namespace][method];
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toLength = toLength$1;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var has$1 = has$5;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$1;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has = has$5;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$1 = fails$5;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var redefine = redefine$1.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var requireObjectCoercible = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$1 = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var DESCRIPTORS = descriptors;
var fails = fails$5;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$1;
var IndexedObject = indexedObject;

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const widthBySize = {
  small: 16,
  medium: 24,
  large: 32
};
const WsIcon$1 = /*#__PURE__*/styled.svg.withConfig({
  displayName: "styledws-icon__WsIcon",
  componentId: "sc-1n95uyw-0"
})(props => {
  const {
    size: propSize = 'medium',
    color,
    fill,
    disabled,
    onClick,
    theme: propTheme
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  const size = theme$1.getSpacing(propSize in widthBySize ? widthBySize[propSize] : propSize);
  return css(["flex-shrink:0;width:", ";height:", ";color:", ";fill:", ";", ";", ""], size, size, color ? theme$1.getColor(color) || color : 'inherit', fill ? theme$1.getColor(fill) || fill : 'currentColor', onClick && 'cursor: pointer;', disabled && css(["opacity:0.5;cursor:not-allowed;pointer-events:none;"]));
});
const S = {
  WsIcon: WsIcon$1
};

/**
 * SvgIcon
 */
const WsIcon = _a => {
  var {
      className,
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  return jsx(S.WsIcon, Object.assign({
    className: classNames('WsIcon', className),
    viewBox: "0 0 24 24"
  }, props, {
    children: children
  }));
};
/**
 * convenient helper to create simple svg icons
 * @param path
 * @param displayName
 * @param defaultProps
 * @returns
 */
const createSvgIcon = (path, displayName, defaultProps) => {
  const Component = props => jsx(WsIcon, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon": displayName,
    "aria-label": displayName
  }, defaultProps, props, {
    children: path
  }));
  Component.displayName = displayName;
  return Component;
};

const ActiveChat = createSvgIcon(jsx("path", {
  d: "M17 7H7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2Zm0 4H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Zm2-9H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z",
  fill: "currentcolor"
}), 'ActiveChat');

const ActiveDoubleChat = createSvgIcon(jsx("path", {
  d: "M4.503 2.042c-.654.111-1.336.5-1.781 1.015a2.613 2.613 0 0 0-.487.794c-.246.597-.235.274-.235 7.08 0 6.984-.025 6.438.304 6.767.32.32.814.39 1.188.167.092-.055.816-.749 1.608-1.542l1.44-1.443h1.453l.018.99c.019 1.089.044 1.237.289 1.751.357.748 1.003 1.304 1.84 1.585l.28.094 3.74.011 3.74.011 1.26 1.255c.693.69 1.321 1.285 1.395 1.322.364.183.84.099 1.141-.201.326-.327.304.098.304-5.767 0-5.707.008-5.488-.235-6.08a2.934 2.934 0 0 0-1.469-1.539c-.513-.247-.669-.278-1.526-.301l-.77-.02V6.354c0-1.79-.017-1.974-.235-2.503a2.934 2.934 0 0 0-1.469-1.539c-.653-.314-.125-.289-6.176-.297-2.981-.003-5.509.008-5.617.027M15.34 4.066c.253.087.507.341.594.594.057.168.066.408.066 1.765v1.571l-2.77.014c-2.364.012-2.799.023-2.97.076-.963.299-1.675.918-2.022 1.758-.206.5-.238.762-.238 1.951v1.079l-1.07.014c-.923.011-1.092.023-1.23.084-.101.046-.443.354-.93.839l-.77.766V9.716c0-5.466-.02-5.098.3-5.418.312-.312-.093-.291 5.683-.295 4.706-.003 5.18.003 5.357.063m4 6c.115.039.263.135.361.233.315.315.299.072.299 4.416v3.861l-.55-.543c-.302-.299-.631-.586-.73-.638l-.18-.095-3.92-.02-3.92-.02-.178-.1c-.208-.117-.421-.379-.48-.591-.027-.096-.042-1.138-.042-2.932 0-3.14-.01-3.029.3-3.339.309-.309.022-.291 4.683-.295 3.775-.003 4.181.003 4.357.063m-6.703 2.571c-.104.104-.117.144-.117.363s.013.259.117.363l.117.117h4.492l.117-.117c.104-.104.117-.144.117-.363s-.013-.259-.117-.363l-.117-.117h-4.492l-.117.117m0 2c-.104.104-.117.144-.117.363s.013.259.117.363l.117.117h4.492l.117-.117c.104-.104.117-.144.117-.363s-.013-.259-.117-.363l-.117-.117h-4.492l-.117.117",
  fill: "currentcolor"
}), 'ActiveDoubleChat');

const ActiveNote = createSvgIcon(jsx("path", {
  d: "M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm-2-4H8a1 1 0 0 0 0 2h6c.265 0 .56-.105.747-.293.188-.187.253-.442.253-.707 0-.265-.066-.52-.253-.707A1.096 1.096 0 0 0 14 10Zm6-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v13Z",
  fill: "currentcolor"
}), 'ActiveNote');

const ActiveTag = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "M6.444 6.169A1 1 0 1 1 7.556 7.83a1 1 0 0 1-1.112-1.66ZM12.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.23 2.32 9.48 9.46c.18.19.284.439.29.7a.998.998 0 0 1-.29.71L13.2 21.7a1 1 0 0 1-.71.29 1.05 1.05 0 0 1-.71-.29l-9.49-9.5a1.05 1.05 0 0 1-.29-.71v-6a1 1 0 0 1 .29-.71l2.5-2.49A1 1 0 0 1 5.5 2h6a1 1 0 0 1 .73.32ZM4 11.09l8.49 8.5 7.09-7.1L11.08 4H5.9L4 5.9v5.19Z",
    fill: "currentcolor"
  })]
}), 'ActiveTag');

const AddUser = createSvgIcon(jsx("path", {
  d: "M21 10.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Zm-7.7 1.72A4.92 4.92 0 0 0 15 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 2 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28ZM10 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z",
  fill: "currentcolor"
}), 'AddUser');

const Analysis = createSvgIcon(jsx("path", {
  d: "M7.5 16A1.5 1.5 0 0 0 9 14.5a.77.77 0 0 0 0-.15l2.79-2.79h.46l1.61 1.61v.08a1.5 1.5 0 1 0 3 0v-.08L20.5 9.5A1.5 1.5 0 1 0 19 8a.767.767 0 0 0 0 .15l-3.61 3.61h-.16L13.5 10a1.5 1.5 0 1 0-3 0l-3 3a1.5 1.5 0 1 0 0 3ZM21 20H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'Analysis');

const ApplicantsAssistants = createSvgIcon(jsx("path", {
  d: "M8 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-4-9A10 10 0 0 0 2 12a9.89 9.89 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20Zm0 18H5.41l.93-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8 8 0 1 1 12 20Z",
  fill: "currentcolor"
}), 'ApplicantsAssistants');

const ArrowCircle = createSvgIcon(jsx("path", {
  d: "m12.59 13-2.3 2.29a1 1 0 0 0 0 1.42 1.002 1.002 0 0 0 1.42 0l4-4c.091-.095.162-.207.21-.33a1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1.003 1.003 0 1 0-1.42 1.42l2.3 2.29H3a1 1 0 1 0 0 2h9.59ZM12 2a10 10 0 0 0-9 5.55 1.006 1.006 0 1 0 1.8.9A8 8 0 1 1 12 20a7.93 7.93 0 0 1-7.16-4.45 1.006 1.006 0 0 0-1.8.9A10 10 0 1 0 12 2Z",
  fill: "currentcolor"
}), 'ArrowCircle');

const ArrowDown = createSvgIcon(jsx("path", {
  d: "M17.71 11.29a1 1 0 0 0-1.42 0L13 14.59V7a1 1 0 1 0-2 0v7.59l-3.29-3.3a1.004 1.004 0 1 0-1.42 1.42l5 5c.095.091.207.162.33.21a.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l5-5a.999.999 0 0 0 0-1.42Z",
  fill: "currentcolor"
}), 'ArrowDown');

const ArrowLeftNew = createSvgIcon(jsx("path", {
  d: "M12.71 17.71a1 1 0 0 0 0-1.42L9.41 13H17a1 1 0 1 0 0-2H9.41l3.3-3.29a1.004 1.004 0 1 0-1.42-1.42l-5 5a1 1 0 0 0-.21.33.94.94 0 0 0 0 .76 1 1 0 0 0 .21.33l5 5a.999.999 0 0 0 1.42 0Z",
  fill: "currentcolor"
}), 'ArrowLeftNew');

const ArrowLeft = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.533 21.516a1 1 0 0 1-1.415 0l-8.254-8.255a1 1 0 0 1 0-1.414l8.255-8.255a1 1 0 1 1 1.414 1.415l-7.548 7.547 7.548 7.548a1 1 0 0 1 0 1.414Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.456 12.554a1 1 0 0 1-1 1H4.717a1 1 0 1 1 0-2h16.74a1 1 0 0 1 1 1Z",
    fill: "currentcolor"
  })]
}), 'ArrowLeft');

const ArrowRight = createSvgIcon(jsx("path", {
  d: "M11.29 6.29a1 1 0 0 0 0 1.42l3.3 3.29H7a1 1 0 1 0 0 2h7.59l-3.3 3.29a1.004 1.004 0 1 0 1.42 1.42l5-5c.091-.095.162-.207.21-.33a.94.94 0 0 0 0-.76 1 1 0 0 0-.21-.33l-5-5a1 1 0 0 0-1.42 0Z",
  fill: "currentcolor"
}), 'ArrowRight');

const ArrowUp = createSvgIcon(jsx("path", {
  d: "M6.29 12.71a1 1 0 0 0 1.42 0L11 9.41V17a1 1 0 1 0 2 0V9.41l3.29 3.3a1.004 1.004 0 1 0 1.42-1.42l-5-5a1 1 0 0 0-.33-.21.94.94 0 0 0-.76 0 1 1 0 0 0-.33.21l-5 5a1 1 0 0 0 0 1.42Z",
  fill: "currentcolor"
}), 'ArrowUp');

const ArrowsCollapse = createSvgIcon(jsx("path", {
  d: "m13.792 6.8-.709.718v-4.12a.898.898 0 1 0-1.794 0v4.12l-.71-.718a.898.898 0 0 0-1.47.292.898.898 0 0 0 .197.983l2.243 2.244a.898.898 0 0 0 .296.189c.218.09.463.09.682 0a.898.898 0 0 0 .296-.189l2.243-2.244A.901.901 0 0 0 13.792 6.8ZM5.35 12.19c0-.42.34-.76.76-.76h11.78a.76.76 0 1 1 0 1.52H6.11a.76.76 0 0 1-.76-.76Zm5.7 4.292-.751.718a.983.983 0 0 1-.675.264.983.983 0 0 1-.674-.264.877.877 0 0 1-.28-.637c0-.24.1-.469.28-.638l2.375-2.244a.959.959 0 0 1 .313-.189 1 1 0 0 1 .722 0 .96.96 0 0 1 .314.189l2.375 2.244c.089.084.16.183.208.292a.854.854 0 0 1 0 .69.952.952 0 0 1-.517.489.997.997 0 0 1-1.04-.196l-.75-.718v4.12c0 .238-.1.467-.279.635a.979.979 0 0 1-.672.263.98.98 0 0 1-.671-.263.874.874 0 0 1-.279-.635v-4.12Z",
  fill: "currentcolor"
}), 'ArrowsCollapse');

const ArrowsExpand = createSvgIcon(jsx("path", {
  d: "M5 3.525c0-.428.358-.775.8-.775h12.4c.442 0 .8.347.8.775a.788.788 0 0 1-.8.775H5.8a.788.788 0 0 1-.8-.775Zm9.629 11.431-1.83 1.56V7.578l1.83 1.56a.82.82 0 0 0 .26.148.925.925 0 0 0 .615 0 .82.82 0 0 0 .26-.149.683.683 0 0 0 .175-.22.59.59 0 0 0 0-.522.683.683 0 0 0-.175-.22l-3.197-2.713a.932.932 0 0 0-1.135 0L8.235 8.174a.685.685 0 0 0-.174.221.593.593 0 0 0 0 .521c.04.083.1.158.174.221a.825.825 0 0 0 .26.148.928.928 0 0 0 .615 0 .825.825 0 0 0 .26-.148l1.83-1.56v8.939l-1.83-1.56a.88.88 0 0 0-.568-.2.88.88 0 0 0-.567.2.633.633 0 0 0-.235.482c0 .18.085.353.235.481l3.197 2.713a.83.83 0 0 0 .264.142.867.867 0 0 0 .607 0 .831.831 0 0 0 .264-.142l3.197-2.713c.15-.128.235-.3.235-.482a.633.633 0 0 0-.235-.481.825.825 0 0 0-.26-.148.93.93 0 0 0-.308-.051.88.88 0 0 0-.567.199ZM5.8 19.7c-.442 0-.8.347-.8.775 0 .428.358.775.8.775h12.4c.442 0 .8-.347.8-.775a.788.788 0 0 0-.8-.775H5.8Z",
  fill: "currentcolor"
}), 'ArrowsExpand');

const Badge = createSvgIcon(jsx("path", {
  d: "m20.87 17.25-2.71-4.68a7 7 0 1 0-12.32 0l-2.71 4.68a1 1 0 0 0 .87 1.5h2.87l1.46 2.46a1 1 0 0 0 .18.22 1 1 0 0 0 .69.28h.14a1 1 0 0 0 .73-.49L12 17.9l1.93 3.35a1.001 1.001 0 0 0 .73.48h.14a1 1 0 0 0 .7-.28.867.867 0 0 0 .17-.21l1.46-2.46H20a1 1 0 0 0 .87-.5 1 1 0 0 0 0-1.03ZM9.19 18.78l-.89-1.49a.999.999 0 0 0-.85-.49H5.72l1.43-2.48a7 7 0 0 0 3.57 1.84l-1.53 2.62ZM12 14.25a5 5 0 1 1 0-9.998 5 5 0 0 1 0 9.998Zm4.55 2.55a1 1 0 0 0-.85.49l-.89 1.49-1.52-2.65a7.06 7.06 0 0 0 3.56-1.84l1.43 2.48-1.73.03Z",
  fill: "currentcolor"
}), 'Badge');

const Bag = createSvgIcon(jsx("path", {
  d: "M19 6.5h-3v-1a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3Zm-9-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4v-1Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V13a21.71 21.71 0 0 0 8 1.53A21.75 21.75 0 0 0 20 13v5.5Zm0-7.69a19.89 19.89 0 0 1-16 0V9.5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1.31Z",
  fill: "currentcolor"
}), 'Bag');

const Bell = createSvgIcon(jsx("path", {
  d: "M18 13.18V10a6 6 0 0 0-5-5.91V3a1 1 0 0 0-2 0v1.09A6 6 0 0 0 6 10v3.18A3 3 0 0 0 4 16v2a1 1 0 0 0 1 1h3.14a4 4 0 0 0 7.72 0H19a1 1 0 0 0 1-1v-2a3 3 0 0 0-2-2.82ZM8 10a4 4 0 0 1 8 0v3H8v-3Zm4 10a2 2 0 0 1-1.72-1h3.44A2 2 0 0 1 12 20Zm6-3H6v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1Z",
  fill: "currentcolor"
}), 'Bell');

const Blocked = createSvgIcon(jsx("path", {
  d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 0 1-8-8 7.92 7.92 0 0 1 1.69-4.9L16.9 18.31A7.92 7.92 0 0 1 12 20Zm6.31-3.1L7.1 5.69A7.92 7.92 0 0 1 12 4a8 8 0 0 1 8 8 7.92 7.92 0 0 1-1.69 4.9Z",
  fill: "currentcolor"
}), 'Blocked');

const Bold = createSvgIcon(jsx("path", {
  d: "M16.5 9.5A3.5 3.5 0 0 0 13 6H8.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1H13a3.49 3.49 0 0 0 2.44-6 3.5 3.5 0 0 0 1.06-2.5ZM13 16H9.5v-3H13a1.5 1.5 0 1 1 0 3Zm0-5H9.5V8H13a1.5 1.5 0 0 1 0 3Z",
  fill: "currentcolor"
}), 'Bold');

const BrokenChain = createSvgIcon(jsx("path", {
  d: "M4.18 10.804a.8.8 0 1 0 .206-1.585l-1.394-.348A.792.792 0 1 0 2.58 10.4l1.394.372a.616.616 0 0 0 .206.032Zm3.059-4.43a.792.792 0 0 0 .792.587.65.65 0 0 0 .206 0 .792.792 0 0 0 .555-.967L8.42 4.6a.792.792 0 1 0-1.53.412l.349 1.363Zm3.827 7.925a.793.793 0 0 0-1.149 0l-2.773 2.82a1.751 1.751 0 0 1-2.425 0 1.703 1.703 0 0 1 0-2.424L7.54 11.92a.791.791 0 1 0-1.117-1.117l-2.845 2.765a3.318 3.318 0 0 0 4.691 4.692l2.797-2.798a.793.793 0 0 0 0-1.164ZM4.513 7.634a.792.792 0 0 0 1.117 0 .792.792 0 0 0 0-1.117L4.608 5.495a.792.792 0 0 0-1.117 1.117l1.022 1.022Zm12.742 5.809-1.395-.373a.791.791 0 1 0-.396 1.53l1.395.372h.206a.8.8 0 0 0 .206-1.585l-.016.056Zm-4.66 4.025a.792.792 0 0 0-1.529.412l.373 1.395a.792.792 0 0 0 .792.586.91.91 0 0 0 .206 0 .793.793 0 0 0 .563-.974l-.404-1.419Zm2.726-1.244a.793.793 0 0 0-1.117 1.117l1.022 1.023a.793.793 0 0 0 1.118 0 .792.792 0 0 0 0-1.118l-1.023-1.022Zm1.886-8.265a3.296 3.296 0 0 0-5.642-2.377L8.768 8.403a.81.81 0 1 0 1.15 1.141l2.773-2.82a1.751 1.751 0 0 1 2.425 0 1.704 1.704 0 0 1 0 2.424l-2.822 2.773a.792.792 0 0 0 0 1.118.792.792 0 0 0 1.118 0l2.845-2.766a3.32 3.32 0 0 0 .95-2.314Z",
  fill: "currentcolor"
}), 'BrokenChain');

const Brush = createSvgIcon(jsx("path", {
  d: "M12 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm6-17H6a1 1 0 0 0-1 1v9a3 3 0 0 0 3 3h1v2.37a4 4 0 1 0 6 0V14h1a3 3 0 0 0 3-3V2a1 1 0 0 0-1-1Zm-6 20a2 2 0 0 1-1.33-3.48.999.999 0 0 0 .33-.74V14h2v2.78a1 1 0 0 0 .33.74A2 2 0 0 1 12 21Zm5-10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1h10v1Zm0-3H7V3h10v5Z",
  fill: "currentcolor"
}), 'Brush');

const CalendarNew = createSvgIcon(jsx("path", {
  d: "M19 3.579h-2V2.526c0-.279-.105-.547-.293-.744A.975.975 0 0 0 16 1.474c-.265 0-.52.11-.707.308a1.082 1.082 0 0 0-.293.744V3.58H9V2.526c0-.279-.105-.547-.293-.744A.975.975 0 0 0 8 1.474c-.265 0-.52.11-.707.308A1.081 1.081 0 0 0 7 2.526V3.58H5c-.796 0-1.559.333-2.121.925A3.244 3.244 0 0 0 2 6.737v12.631c0 .838.316 1.641.879 2.233A2.926 2.926 0 0 0 5 22.526h14a2.92 2.92 0 0 0 2.121-.925A3.244 3.244 0 0 0 22 19.368V6.737c0-.838-.316-1.641-.879-2.233A2.926 2.926 0 0 0 19 3.579Zm1 15.79c0 .279-.105.546-.293.744a.975.975 0 0 1-.707.308H5a.975.975 0 0 1-.707-.308A1.081 1.081 0 0 1 4 19.368V12h16v7.368Zm0-9.474H4V6.737c0-.28.105-.547.293-.745A.975.975 0 0 1 5 5.684h2v1.053c0 .279.105.547.293.744A.975.975 0 0 0 8 7.79c.265 0 .52-.11.707-.308.188-.197.293-.465.293-.744V5.684h6v1.053c0 .279.105.547.293.744A.975.975 0 0 0 16 7.79c.265 0 .52-.11.707-.308.188-.197.293-.465.293-.744V5.684h2c.265 0 .52.111.707.308.188.198.293.466.293.745v3.158Z",
  fill: "currentcolor"
}), 'CalendarNew');

const Calendar = createSvgIcon(jsx("path", {
  d: "M12 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-5 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 4h-1V3a1 1 0 0 0-2 0v1H8V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9h16v9Zm0-11H4V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1ZM7 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "currentcolor"
}), 'Calendar');

const ChatActive = createSvgIcon(jsx("path", {
  d: "M17 7H7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2Zm0 4H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Zm2-9H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z",
  fill: "currentcolor"
}), 'ChatActive');

const ChatNew = createSvgIcon(jsx("path", {
  d: "M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z",
  fill: "currentcolor"
}), 'ChatNew');

const Chat = createSvgIcon(jsx("path", {
  d: "M11 11h6a1 1 0 0 0 0-2h-6a1 1 0 1 0 0 2ZM7 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm5-11A10 10 0 0 0 2 12a9.89 9.89 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 1 0 0-20Zm0 18H5.41l.93-.93a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.7A8 8 0 1 1 12 20Zm5-7h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'Chat');

const ChatInactive = createSvgIcon(jsx("path", {
  d: "M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z",
  fill: "currentcolor"
}), 'ChatInactive');

const CheckmarkCircle = createSvgIcon(jsx("path", {
  d: "m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1.002 1.002 0 1 0-1.41-1.42ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z",
  fill: "currentcolor"
}), 'CheckmarkCircle');

const CheckmarkSync = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.95 5.305C11.7-1.392 21.9 3.21 21.9 11.758a.9.9 0 0 1-1.8 0c0-6.805-8.076-10.742-13.746-5.307l1.834.004a.9.9 0 1 1-.003 1.8l-4.158-.01a.9.9 0 0 1-.881-1.077.906.906 0 0 1-.01-.147l.034-3.984a.9.9 0 1 1 1.8.015l-.02 2.253Zm10.4 3.036a.9.9 0 0 1 .196 1.257l-3.778 5.175a.9.9 0 0 1-1.412.054.913.913 0 0 1-.129-.103l-1.65-1.581a.9.9 0 1 1 1.246-1.3l1.091 1.046 3.178-4.352a.9.9 0 0 1 1.257-.196ZM3 11.34a.9.9 0 0 1 .9.9c0 6.806 8.076 10.743 13.746 5.308l-1.834-.004a.9.9 0 1 1 .003-1.8l4.158.01a.9.9 0 0 1 .88 1.077.912.912 0 0 1 .012.147l-.035 3.984a.9.9 0 1 1-1.8-.015l.02-2.253C12.3 25.392 2.1 20.791 2.1 12.242a.9.9 0 0 1 .9-.9Z",
  fill: "currentcolor"
}), 'CheckmarkSync');

const Checkmark = createSvgIcon(jsx("path", {
  d: "M18.71 7.21a.999.999 0 0 0-1.42 0l-7.45 7.46-3.13-3.14A1.023 1.023 0 0 0 5.29 13l3.84 3.84a1 1 0 0 0 1.42 0l8.16-8.16a.999.999 0 0 0 0-1.47Z",
  fill: "currentcolor"
}), 'Checkmark');

const ChevronDown = createSvgIcon(jsx("path", {
  d: "m12.753 15.552 5.65-5.66a1.001 1.001 0 1 0-1.41-1.42l-5 4.95-4.95-4.95a1 1 0 0 0-1.41 0 1 1 0 0 0-.3.71 1 1 0 0 0 .3.71l5.65 5.66a1 1 0 0 0 1.47 0Z",
  fill: "currentcolor"
}), 'ChevronDown');

const ChevronLeft = createSvgIcon(jsx("path", {
  d: "m8.46 12.71 5.66 5.65a1.002 1.002 0 0 0 1.71-.705 1 1 0 0 0-.29-.705l-4.95-5L15.54 7a1 1 0 0 0 0-1.41 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3l-5.66 5.65a1 1 0 0 0 0 1.47Z",
  fill: "currentcolor"
}), 'ChevronLeft');

const ChevronRight = createSvgIcon(jsx("path", {
  d: "M15.54 11.29 9.88 5.64a1 1 0 1 0-1.42 1.41l4.95 5L8.46 17a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3.999.999 0 0 0 .71-.3l5.66-5.65a1 1 0 0 0 0-1.47Z",
  fill: "currentcolor"
}), 'ChevronRight');

const ChevronUp = createSvgIcon(jsx("path", {
  d: "m11.278 8.503-5.65 5.66a1 1 0 1 0 1.41 1.42l5-4.95 4.95 4.95a1 1 0 0 0 1.41 0 1 1 0 0 0 .3-.71.998.998 0 0 0-.3-.71l-5.65-5.66a1 1 0 0 0-1.47 0Z",
  fill: "currentcolor"
}), 'ChevronUp');

const CircleCross = createSvgIcon(jsx("path", {
  d: "M15.71 8.29a1 1 0 0 0-1.42 0L12 10.59l-2.29-2.3a1.004 1.004 0 1 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 .325 1.639 1.001 1.001 0 0 0 1.095-.219l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12l2.3-2.29a1 1 0 0 0 0-1.42Zm3.36-3.36A10.001 10.001 0 1 0 4.93 19.07 10 10 0 1 0 19.07 4.93Zm-1.41 12.73A8 8 0 1 1 20 12a7.953 7.953 0 0 1-2.34 5.66Z",
  fill: "currentcolor"
}), 'CircleCross');

const CirclePlus = createSvgIcon(jsx("path", {
  d: "M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm4-9h-3V6a1 1 0 0 0-2 0v3H6a1 1 0 0 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'CirclePlus');

const Circle = createSvgIcon(jsx("path", {
  d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z",
  fill: "currentcolor"
}), 'Circle');

const ClipboardAlt = createSvgIcon(jsx("path", {
  d: "M17 4h-1.18A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm-7 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4V5Zm8 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1v12Z",
  fill: "currentcolor"
}), 'ClipboardAlt');

const Clipboard = createSvgIcon(jsx("path", {
  d: "M13 14H9a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm4-10h-1.18A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm-7 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4V5Zm8 14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1v12Zm-3-9H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'Clipboard');

const Clock = createSvgIcon(jsx("path", {
  d: "M15 11h-2V7a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2Zm-3-9a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z",
  fill: "currentcolor"
}), 'Clock');

const CloudDownload = createSvgIcon(jsx("path", {
  d: "M13.29 15.29 12 16.59V11a1 1 0 0 0-2 0v5.59l-1.29-1.3a1.004 1.004 0 1 0-1.42 1.42l3 3a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0c.123-.048.235-.119.33-.21l3-3a1.004 1.004 0 1 0-1.42-1.42Zm4.13-11.07A7 7 0 0 0 4.06 6.11 4 4 0 0 0 5 14a1 1 0 0 0 0-2 2 2 0 1 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 .24 5.84 1 1 0 1 0 .5 1.94 5 5 0 0 0 .17-9.62Z",
  fill: "currentcolor"
}), 'CloudDownload');

const Collapse = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "M6.594 7.013 2.3 11.303a1 1 0 0 0-.3.71.989.989 0 0 0 .3.71l4.294 4.24a1.011 1.011 0 0 0 .72.296 1.024 1.024 0 0 0 .718-.296.993.993 0 0 0 0-1.41l-3.585-3.54 3.585-3.54a.994.994 0 0 0 0-1.41 1.012 1.012 0 0 0-.708-.321 1.024 1.024 0 0 0-.73.27Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.872 5.5c0-.552.453-1 1.012-1h8.103c.56 0 1.013.448 1.013 1s-.453 1-1.013 1h-8.102c-.56 0-1.013-.448-1.013-1Zm0 6.5c0-.552.453-1 1.012-1h8.103c.56 0 1.013.448 1.013 1s-.453 1-1.013 1h-8.102c-.56 0-1.013-.448-1.013-1Zm0 6.5c0-.552.453-1 1.012-1h8.103c.56 0 1.013.448 1.013 1s-.453 1-1.013 1h-8.102c-.56 0-1.013-.448-1.013-1Z",
    fill: "currentcolor"
  })]
}), 'Collapse');

const Company = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.75 4.6h-8a.4.4 0 0 0-.4.4v14c0 .22.18.4.4.4h2v-3.955l.002-.001V15.3c0-.08.064-.144.144-.144h3.656c.11 0 .2.09.2.2V19.4h1.998a.4.4 0 0 0 .4-.4V5a.4.4 0 0 0-.4-.4ZM9.352 19.4v-2.644a.2.2 0 0 0-.2-.2H8.35a.2.2 0 0 0-.2.2V19.4h1.202ZM4.75 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8c.173 0 .34-.022.5-.063V21h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-4.5V5a2 2 0 0 0-2-2h-8Zm14.5 5.6h-4.4v10.8h4.4a.4.4 0 0 0 .4-.4V9a.4.4 0 0 0-.4-.4ZM6.15 11a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2v-1.6a.2.2 0 0 0-.2-.2h-1.6Zm3.3.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.6ZM6.15 6a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V6.2a.2.2 0 0 0-.2-.2h-1.6Zm3.3.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V6.2Zm7 4.8a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2v-1.6a.2.2 0 0 0-.2-.2h-1.6Zm-.2 4.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.6Z",
  fill: "currentcolor"
}), 'Company');

const ComposeMessage = createSvgIcon(jsx("path", {
  d: "M18 5h-4a1 1 0 1 0 0 2h4a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H8a1 1 0 0 1-1-1v-1a1 1 0 1 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 1.518-.18 1 1 0 0 0 .163-.55V8A3.002 3.002 0 0 0 18 5Zm-9.42 7H11a1 1 0 0 0 1-1V8.58a1 1 0 0 0-.29-.71L6.13 2.29a1 1 0 0 0-1.41 0L2.29 4.72a1 1 0 0 0 0 1.41l5.58 5.58a1 1 0 0 0 .71.29ZM5.42 4.41 10 8.99v1H9L4.41 5.42l1.01-1.01Z",
  fill: "currentcolor"
}), 'ComposeMessage');

const Compose = createSvgIcon(jsx("path", {
  d: "M18 5h-4a1 1 0 1 0 0 2h4a1 1 0 0 1 1 1v9.72l-1.57-1.45a1 1 0 0 0-.68-.27H8a1 1 0 0 1-1-1v-1a1 1 0 1 0-2 0v1a3 3 0 0 0 3 3h8.36l3 2.73a1 1 0 0 0 1.518-.18 1 1 0 0 0 .163-.55V8A3.002 3.002 0 0 0 18 5Zm-9.42 7H11a1 1 0 0 0 1-1V8.58a1 1 0 0 0-.29-.71L6.13 2.29a1 1 0 0 0-1.41 0L2.29 4.72a1 1 0 0 0 0 1.41l5.58 5.58a1 1 0 0 0 .71.29ZM5.42 4.41 10 8.99v1H9L4.41 5.42l1.01-1.01Z",
  fill: "currentcolor"
}), 'Compose');

const ContactCard = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6H6C5 6 4 7 4 8v8.444C4 17.574 4.6 18 5.81 18h12.38c1.21 0 1.81-.37 1.81-1.5V8c0-1.5-.762-2-2-2ZM5.81 4C3.706 4 2 5.592 2 7.556v8.888C2 18.408 3.706 20 5.81 20h12.38c2.104 0 3.81-1.592 3.81-3.556V7.556C22 5.592 20.294 4 18.19 4H5.81Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.153 9.6c-.625 0-1.132.473-1.132 1.057 0 .583.507 1.056 1.132 1.056.625 0 1.132-.473 1.132-1.056 0-.584-.507-1.057-1.132-1.057Zm-2.656 1.057c0-1.37 1.19-2.48 2.656-2.48 1.467 0 2.656 1.11 2.656 2.48 0 1.369-1.189 2.478-2.656 2.478s-2.656-1.11-2.656-2.478Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.143 13.64c-.578 0-1.12.195-1.508.525-.386.328-.587.757-.587 1.188 0 .393-.341.711-.762.711s-.762-.318-.762-.71c0-.855.4-1.66 1.086-2.241.683-.58 1.595-.895 2.533-.895s1.85.315 2.533.895c.685.581 1.086 1.386 1.086 2.24 0 .393-.341.711-.762.711-.42 0-.762-.318-.762-.71 0-.432-.201-.861-.587-1.189-.389-.33-.93-.525-1.508-.525ZM14.19 11c0-.417.363-1 .81-1h3.429c.447 0 .81.583.81 1 0 .417-.363 1-.81 1H15c-.447 0-.81-.583-.81-1Zm0 3c0-.417.363-1 .81-1h3.429c.447 0 .81.583.81 1 0 .417-.363 1-.81 1H15c-.447 0-.81-.583-.81-1Z",
    fill: "currentcolor"
  })]
}), 'ContactCard');

const Copy = createSvgIcon(jsx("path", {
  d: "M21 8.94a1.307 1.307 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19.32.32 0 0 0-.09 0 .88.88 0 0 0-.33-.11H10a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h1a3 3 0 0 0 3-3V8.94Zm-6-3.53L17.59 8H16a1 1 0 0 1-1-1V5.41ZM15 19a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v7a3 3 0 0 0 3 3h5v1Zm4-4a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3v5Z",
  fill: "currentcolor"
}), 'Copy');

const CrossCircle = createSvgIcon(jsx("path", {
  d: "M15.71 8.29a1 1 0 0 0-1.42 0L12 10.59l-2.29-2.3a1.004 1.004 0 1 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 .325 1.639 1.001 1.001 0 0 0 1.095-.219l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12l2.3-2.29a1 1 0 0 0 0-1.42Zm3.36-3.36A10.001 10.001 0 1 0 4.93 19.07 10 10 0 1 0 19.07 4.93Zm-1.41 12.73A8 8 0 1 1 20 12a7.953 7.953 0 0 1-2.34 5.66Z",
  fill: "currentcolor"
}), 'CrossCircle');

const Cross = createSvgIcon(jsx("path", {
  d: "m13.41 12 4.3-4.29a1.004 1.004 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1.004 1.004 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l4.29-4.3 4.29 4.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L13.41 12Z",
  fill: "currentcolor"
}), 'Cross');

const Crown = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.357 8.594a.34.34 0 0 0-.126-.09.418.418 0 0 0-.326 0 .34.34 0 0 0-.127.09L9.55 11.2 7.73 9.71a.382.382 0 0 0-.18-.079.426.426 0 0 0-.204.017.347.347 0 0 0-.159.106.253.253 0 0 0-.06.16v3.755c0 .306.15.6.414.816.265.217.624.338.998.338h7.06c.374 0 .733-.121.998-.338.264-.216.413-.51.413-.816V9.915a.253.253 0 0 0-.06-.16.347.347 0 0 0-.158-.107.426.426 0 0 0-.204-.017.383.383 0 0 0-.18.08l-1.82 1.489-2.23-2.606Z",
    fill: "currentcolor"
  }), jsx("path", {
    d: "M8.403 8.572a1.412 1.412 0 1 1-2.824 0 1.412 1.412 0 0 1 2.824 0ZM18.42 8.47a1.412 1.412 0 1 1-2.823 0 1.412 1.412 0 0 1 2.824 0Zm-4.94-1.058a1.412 1.412 0 1 1-2.824 0 1.412 1.412 0 0 1 2.823 0Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.127 16.941c0-.585.474-1.059 1.059-1.059h7.764a1.059 1.059 0 1 1 0 2.118H8.186a1.059 1.059 0 0 1-1.06-1.059Z",
    fill: "currentcolor"
  })]
}), 'Crown');

const DataChevronDown = createSvgIcon(jsx("path", {
  d: "m20.257 10.468-6.493 6.768a2.425 2.425 0 0 1-3.534 0l-6.493-6.768C2.157 8.822 3.286 6 5.517 6h12.985c2.231 0 3.334 2.822 1.755 4.468Z",
  fill: "currentcolor"
}), 'DataChevronDown');

const DataChevronUp = createSvgIcon(jsx("path", {
  d: "m20.257 13.532-6.493-6.768a2.425 2.425 0 0 0-3.534 0l-6.493 6.768C2.157 15.178 3.286 18 5.517 18h12.985c2.231 0 3.334-2.822 1.755-4.468Z",
  fill: "currentcolor"
}), 'DataChevronUp');

const DepartmentsNew = createSvgIcon(jsx("path", {
  d: "M14.1 7.8h1.05a1.05 1.05 0 0 0 0-2.1H14.1a1.05 1.05 0 0 0 0 2.1Zm0 4.2h1.05a1.05 1.05 0 0 0 0-2.1H14.1a1.05 1.05 0 0 0 0 2.1ZM8.85 7.8H9.9a1.05 1.05 0 0 0 0-2.1H8.85a1.05 1.05 0 1 0 0 2.1Zm0 4.2H9.9a1.05 1.05 0 0 0 0-2.1H8.85a1.05 1.05 0 1 0 0 2.1Zm12.6 8.4H20.4V2.55a1.05 1.05 0 0 0-1.05-1.05H4.65A1.05 1.05 0 0 0 3.6 2.55V20.4H2.55a1.05 1.05 0 1 0 0 2.1h18.9a1.05 1.05 0 0 0 0-2.1Zm-8.4 0h-2.1v-4.2h2.1v4.2Zm5.25 0h-3.15v-5.25a1.05 1.05 0 0 0-1.05-1.05H9.9a1.05 1.05 0 0 0-1.05 1.05v5.25H5.7V3.6h12.6v16.8Z",
  fill: "currentcolor"
}), 'DepartmentsNew');

const Departments = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.463 2.041c-1.519.24-2.726 1.247-3.195 2.667-.467 1.418-.148 2.852.885 3.975l.24.263-.822 1.297-1.647 2.597-.824 1.3-.28-.023a4.77 4.77 0 0 0-.658.01c-1.685.146-3.055 1.32-3.486 2.986-.273 1.055-.031 2.308.624 3.227.197.276.716.79.98.967.771.523 1.804.774 2.7.656 1.502-.198 2.752-1.2 3.243-2.603l.09-.26h5.37l.092.26c.494 1.402 1.745 2.405 3.245 2.603.896.118 1.929-.133 2.7-.656.264-.178.783-.69.98-.967.655-.919.897-2.172.624-3.227-.431-1.667-1.801-2.84-3.486-2.986a4.77 4.77 0 0 0-.658-.01l-.28.023-.824-1.3-1.648-2.597-.823-1.297.242-.263c1.033-1.123 1.352-2.557.885-3.975a3.623 3.623 0 0 0-.912-1.49c-.57-.579-1.106-.893-1.855-1.083-.435-.11-1.121-.154-1.502-.094Zm.902 2.08c.949.176 1.64 1.16 1.482 2.11-.247 1.491-2.042 2.101-3.13 1.063a1.847 1.847 0 0 1-.038-2.653 1.847 1.847 0 0 1 1.686-.52ZM12 9.888c.215 0 .46-.01.545-.025l.155-.025 1.12 1.77 1.635 2.58.514.812-.267.268c-.447.447-.743.94-.995 1.661-.023.066-.188.07-2.707.07-2.519 0-2.684-.004-2.707-.07-.252-.72-.548-1.214-.995-1.66L8.031 15l.514-.812 1.635-2.58 1.12-1.77.155.025c.085.014.33.025.545.025Zm-5.938 6.373c.25.07.63.312.823.526.356.396.49.793.468 1.372-.014.352-.03.418-.164.69-.178.36-.536.718-.884.882-1.29.611-2.773-.42-2.654-1.844.1-1.185 1.233-1.949 2.41-1.626Zm13.042.026a1.866 1.866 0 0 1 1.245 1.6c.119 1.424-1.364 2.455-2.654 1.844a2.064 2.064 0 0 1-.885-.884c-.14-.282-.15-.33-.162-.725-.011-.349 0-.465.069-.66.35-1 1.387-1.51 2.387-1.175Z",
  fill: "currentcolor"
}), 'Departments');

const DocumentAdd = createSvgIcon(jsx("path", {
  d: "M20 18h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Zm-7 2H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v3a1 1 0 0 0 2 0V8.94a1.307 1.307 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19.29.29 0 0 0-.1 0 1.099 1.099 0 0 0-.31-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2Zm0-14.59L15.59 8H14a1 1 0 0 1-1-1V5.41ZM8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2H8Zm5 8H8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2Zm1-4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'DocumentAdd');

const DocumentApprove = createSvgIcon(jsx("path", {
  d: "M20 8.94a1.307 1.307 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19.32.32 0 0 0-.09 0 .88.88 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94Zm-6-3.53L16.59 8H15a1 1 0 0 1-1-1V5.41ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v9Zm-3.71-6.71L11 15.59l-1.29-1.3a1.004 1.004 0 1 0-1.42 1.42l2 2a1.002 1.002 0 0 0 1.42 0l4-4a1.004 1.004 0 1 0-1.42-1.42Z",
  fill: "currentcolor"
}), 'DocumentApprove');

const DocumentExport = createSvgIcon(jsx("path", {
  d: "M13 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v2a1 1 0 0 0 2 0V8.94a1.307 1.307 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19.32.32 0 0 0-.09 0 .88.88 0 0 0-.33-.11H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2Zm0-14.59L15.59 8H14a1 1 0 0 1-1-1V5.41ZM8 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2H8Zm6 4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm6.71 5.29-2-2a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1.004 1.004 0 1 0 1.42 1.42l.29-.3V21a1 1 0 0 0 2 0v-2.59l.29.3a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095ZM12 18a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2h4Z",
  fill: "currentcolor"
}), 'DocumentExport');

const DocumentSearch = createSvgIcon(jsx("path", {
  d: "M11.997 19.995H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4.999v3a3 3 0 0 0 2.999 2.999h2.999v1a1 1 0 0 0 2 0v-2.06a1.313 1.313 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28L11.746 2.3a1.072 1.072 0 0 0-.28-.19.32.32 0 0 0-.09 0 .88.88 0 0 0-.33-.11H5a3 3 0 0 0-3 3v13.995a3 3 0 0 0 3 3h6.997a1 1 0 1 0 0-2Zm0-14.586 2.59 2.59h-1.59a1 1 0 0 1-1-1v-1.59ZM7 7.999a1 1 0 0 0 0 1.999h1a1 1 0 0 0 0-2H7Zm14.705 12.286-1.17-1.16a3.439 3.439 0 0 0-.54-4.129 3.489 3.489 0 0 0-5.998 2.49 3.46 3.46 0 0 0 5.129 3.049l1.16 1.17a.999.999 0 0 0 1.42 0 .999.999 0 0 0 0-1.42Zm-3.169-1.75a1.54 1.54 0 0 1-2.11 0 1.5 1.5 0 0 1 .01-2.11 1.48 1.48 0 0 1 1-.43 1.47 1.47 0 0 1 1.1 2.54Zm-5.538-6.538H6.999a1 1 0 1 0 0 2h5.998a1 1 0 1 0 0-2Zm-2 5.998a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2h3.998Z",
  fill: "currentcolor"
}), 'DocumentSearch');

const Document = createSvgIcon(jsx("path", {
  d: "M9 10h1a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2Zm0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H9Zm11-3.06a1.307 1.307 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19.32.32 0 0 0-.09 0 .88.88 0 0 0-.33-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94Zm-6-3.53L16.59 8H15a1 1 0 0 1-1-1V5.41ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v9Zm-3-3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'Document');

const DollarCircle = createSvgIcon(jsx("path", {
  d: "M11 9h4a1 1 0 1 0 0-2h-2V6a1 1 0 0 0-2 0v1a3 3 0 1 0 0 6h2a1 1 0 0 1 0 2H9a1 1 0 0 0 0 2h2v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 0-6h-2a1 1 0 0 1 0-2Zm1-8a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm0 20a9 9 0 1 1 0-18 9 9 0 0 1 0 18Z",
  fill: "currentcolor"
}), 'DollarCircle');

const DoubleChatActive = createSvgIcon(jsx("path", {
  d: "M4.503 2.042c-.654.111-1.336.5-1.781 1.015a2.613 2.613 0 0 0-.487.794c-.246.597-.235.274-.235 7.08 0 6.984-.025 6.438.304 6.767.32.32.814.39 1.188.167.092-.055.816-.749 1.608-1.542l1.44-1.443h1.453l.018.99c.019 1.089.044 1.237.289 1.751.357.748 1.003 1.304 1.84 1.585l.28.094 3.74.011 3.74.011 1.26 1.255c.693.69 1.321 1.285 1.395 1.322.364.183.84.099 1.141-.201.326-.327.304.098.304-5.767 0-5.707.008-5.488-.235-6.08a2.934 2.934 0 0 0-1.469-1.539c-.513-.247-.669-.278-1.526-.301l-.77-.02V6.354c0-1.79-.017-1.974-.235-2.503a2.934 2.934 0 0 0-1.469-1.539c-.653-.314-.125-.289-6.176-.297-2.981-.003-5.509.008-5.617.027M15.34 4.066c.253.087.507.341.594.594.057.168.066.408.066 1.765v1.571l-2.77.014c-2.364.012-2.799.023-2.97.076-.963.299-1.675.918-2.022 1.758-.206.5-.238.762-.238 1.951v1.079l-1.07.014c-.923.011-1.092.023-1.23.084-.101.046-.443.354-.93.839l-.77.766V9.716c0-5.466-.02-5.098.3-5.418.312-.312-.093-.291 5.683-.295 4.706-.003 5.18.003 5.357.063m4 6c.115.039.263.135.361.233.315.315.299.072.299 4.416v3.861l-.55-.543c-.302-.299-.631-.586-.73-.638l-.18-.095-3.92-.02-3.92-.02-.178-.1c-.208-.117-.421-.379-.48-.591-.027-.096-.042-1.138-.042-2.932 0-3.14-.01-3.029.3-3.339.309-.309.022-.291 4.683-.295 3.775-.003 4.181.003 4.357.063m-6.703 2.571c-.104.104-.117.144-.117.363s.013.259.117.363l.117.117h4.492l.117-.117c.104-.104.117-.144.117-.363s-.013-.259-.117-.363l-.117-.117h-4.492l-.117.117m0 2c-.104.104-.117.144-.117.363s.013.259.117.363l.117.117h4.492l.117-.117c.104-.104.117-.144.117-.363s-.013-.259-.117-.363l-.117-.117h-4.492l-.117.117",
  fill: "currentcolor"
}), 'DoubleChatActive');

const DoubleChat = createSvgIcon(jsx("path", {
  d: "M19 8h-1V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a1 1 0 0 0 .62.92 1 1 0 0 0 1.09-.21l2.81-2.82H8v1.44a3 3 0 0 0 3 3h6.92l2.37 2.38A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V11a3 3 0 0 0-3-3ZM8 11v1.89H6.11a1 1 0 0 0-.71.29L4 14.59V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h-5a3 3 0 0 0-3 3Zm12 7.59-1-1a1 1 0 0 0-.71-.3H11a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7.59Z",
  fill: "currentcolor"
}), 'DoubleChat');

const DoubleChevronLeft = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "m16.536 7-4.24 4.29a1 1 0 0 0 0 1.42l4.24 4.24a1 1 0 1 0 1.42-1.41L14.416 12l3.54-3.54a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42-.05Z",
    fill: "currentcolor"
  }), jsx("path", {
    d: "m10.536 7-4.24 4.29a.999.999 0 0 0 0 1.42l4.24 4.24a1 1 0 1 0 1.42-1.41L8.416 12l3.54-3.54a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42-.05Z",
    fill: "currentcolor"
  })]
}), 'DoubleChevronLeft');

const DoubleChevronRight = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "m7.464 17 4.24-4.29a1 1 0 0 0 0-1.42l-4.24-4.24a1 1 0 1 0-1.42 1.41L9.584 12l-3.54 3.54a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42.05Z",
    fill: "currentcolor"
  }), jsx("path", {
    d: "m13.464 17 4.24-4.29a1 1 0 0 0 0-1.42l-4.24-4.24a1 1 0 1 0-1.42 1.41l3.54 3.54-3.54 3.54a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42.05Z",
    fill: "currentcolor"
  })]
}), 'DoubleChevronRight');

const Download = createSvgIcon(jsx("path", {
  d: "M14.29 15.29 13 16.59V11a1 1 0 1 0-2 0v5.59l-1.29-1.3a1.005 1.005 0 0 0-1.714.71 1.004 1.004 0 0 0 .294.71l3 3c.095.09.207.162.33.21a.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1.004 1.004 0 1 0-1.42-1.42Zm4.13-8.07A7 7 0 0 0 5.06 9.11 4 4 0 0 0 6 17a1 1 0 0 0 0-2 2 2 0 1 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 .24 5.84 1.001 1.001 0 1 0 .5 1.94 5 5 0 0 0 .17-9.62Z",
  fill: "currentcolor"
}), 'Download');

const Drag = createSvgIcon(jsx("path", {
  d: "M6 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM6 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm8 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0-14a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z",
  fill: "currentcolor"
}), 'Drag');

const Draggable = createSvgIcon(jsx("path", {
  d: "M6 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM6 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm8 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0-14a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z",
  fill: "currentcolor"
}), 'Draggable');

const Ellipses = createSvgIcon(jsx("path", {
  d: "M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm14 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
  fill: "currentcolor"
}), 'Ellipses');

const Email = createSvgIcon(jsx("path", {
  d: "M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm-.41 2-5.88 5.88a1.002 1.002 0 0 1-1.42 0L5.41 6h13.18ZM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.41l5.88 5.88a3 3 0 0 0 4.24 0L20 7.41V17Z",
  fill: "currentcolor"
}), 'Email');

const Envelope = createSvgIcon(jsx("path", {
  d: "M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm-.41 2-5.88 5.88a1.002 1.002 0 0 1-1.42 0L5.41 6h13.18ZM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.41l5.88 5.88a3 3 0 0 0 4.24 0L20 7.41V17Z",
  fill: "currentcolor"
}), 'Envelope');

const ErrorNew = createSvgIcon(jsx("path", {
  d: "M12 7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1Zm0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm9.71-7.44-5.27-5.27a1.05 1.05 0 0 0-.71-.29H8.27a1.05 1.05 0 0 0-.71.29L2.29 7.56a1.05 1.05 0 0 0-.29.71v7.46c.004.265.107.518.29.71l5.27 5.27c.192.183.445.286.71.29h7.46a1.05 1.05 0 0 0 .71-.29l5.27-5.27a1.05 1.05 0 0 0 .29-.71V8.27a1.05 1.05 0 0 0-.29-.71ZM20 15.31 15.31 20H8.69L4 15.31V8.69L8.69 4h6.62L20 8.69v6.62Z",
  fill: "currentcolor"
}), 'ErrorNew');

const Error$1 = createSvgIcon(jsx("path", {
  d: "M10 5.833a.833.833 0 0 0-.833.834V10a.833.833 0 1 0 1.666 0V6.667A.833.833 0 0 0 10 5.833Zm0 6.667a.834.834 0 1 0 0 1.668.834.834 0 0 0 0-1.668Zm8.092-6.2L13.7 1.908a.875.875 0 0 0-.592-.241H6.892a.875.875 0 0 0-.592.241L1.908 6.3a.875.875 0 0 0-.241.592v6.216a.88.88 0 0 0 .241.592L6.3 18.092c.16.152.371.238.592.241h6.216a.875.875 0 0 0 .592-.241l4.392-4.392a.875.875 0 0 0 .241-.592V6.892a.875.875 0 0 0-.241-.592Zm-1.425 6.458-3.909 3.909H7.242l-3.909-3.909V7.242l3.909-3.909h5.516l3.909 3.909v5.516Z",
  fill: "currentcolor"
}), 'Error');

const Exit = createSvgIcon(jsx("path", {
  d: "M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1.003 1.003 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1ZM17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 1 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Z",
  fill: "currentcolor"
}), 'Exit');

const Expand = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "m17.406 16.987 4.294-4.29a1 1 0 0 0 .3-.71.989.989 0 0 0-.3-.71l-4.294-4.24a1.014 1.014 0 0 0-.72-.296 1.024 1.024 0 0 0-.718.296.993.993 0 0 0 0 1.41l3.585 3.54-3.585 3.54a.994.994 0 0 0 0 1.41 1.013 1.013 0 0 0 .708.321 1.024 1.024 0 0 0 .73-.27Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.128 18.5c0 .552-.453 1-1.012 1H3.013c-.56 0-1.013-.448-1.013-1s.453-1 1.013-1h8.102c.56 0 1.013.448 1.013 1Zm0-6.5c0 .552-.453 1-1.012 1H3.013C2.453 13 2 12.552 2 12s.453-1 1.013-1h8.102c.56 0 1.013.448 1.013 1Zm0-6.5c0 .552-.453 1-1.012 1H3.013C2.453 6.5 2 6.052 2 5.5s.453-1 1.013-1h8.102c.56 0 1.013.448 1.013 1Z",
    fill: "currentcolor"
  })]
}), 'Expand');

const ExternalLink = createSvgIcon(jsx("path", {
  d: "M18 10.82a1 1 0 0 0-1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7.18a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7.18a1 1 0 0 0-1-1Zm3.92-8.2a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 1 0 0 2h3.59L8.29 14.29a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219L20 5.41V9a1 1 0 0 0 2 0V3a1.001 1.001 0 0 0-.08-.38Z",
  fill: "currentcolor"
}), 'ExternalLink');

const Eye = createSvgIcon(jsx("path", {
  d: "M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8ZM12 18c-3.18 0-6.17-2.29-7.9-6C5.83 8.29 8.82 6 12 6c3.18 0 6.17 2.29 7.9 6-1.73 3.71-4.72 6-7.9 6Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
  fill: "currentcolor"
}), 'Eye');

const FavoriteFile = createSvgIcon(jsx("path", {
  d: "M20 8.94a1.32 1.32 0 0 0-.06-.27v-.09a1.072 1.072 0 0 0-.19-.28l-6-6a1.067 1.067 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94Zm-6-3.53L16.59 8H15a1 1 0 0 1-1-1V5.41ZM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v9Zm-6-7.66A2.92 2.92 0 0 0 8.57 16l2.72 2.72a1.002 1.002 0 0 0 1.42 0L15.43 16A2.92 2.92 0 0 0 12 11.34Zm2 1.93a.92.92 0 0 1 0 1.3l-2 2-2-2a.92.92 0 0 1 1.3-1.3.997.997 0 0 0 1.095.219.999.999 0 0 0 .325-.22.92.92 0 0 1 1.28 0Z",
  fill: "currentcolor"
}), 'FavoriteFile');

const Favorite = createSvgIcon(jsx("path", {
  d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 1.47 1.08l5.1-2.67 5.1 2.67c.14.08.3.12.46.12a1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67Zm-6.15 4a.997.997 0 0 0-.29.88l.72 4.2-3.76-2a1.061 1.061 0 0 0-.94 0l-3.76 2 .72-4.2a.999.999 0 0 0-.29-.88l-3-3 4.21-.61a1 1 0 0 0 .76-.55L12 5.7l1.88 3.82a1 1 0 0 0 .76.55l4.21.61-3 2.99Z",
  fill: "currentcolor"
}), 'Favorite');

const Filter = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.073 7.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm2 0a3.5 3.5 0 0 1-6.833 1.071H4.698c-.166 0-.325-.12-.442-.334a1.729 1.729 0 0 1-.183-.808c0-.304.066-.594.183-.809.117-.214.276-.334.442-.334h8.591a3.501 3.501 0 0 1 6.784 1.214ZM5.93 16.309a1.429 1.429 0 1 1 2.857 0 1.429 1.429 0 0 1-2.857 0Zm-2 0a3.429 3.429 0 0 1 6.662-1.143h8.57c.166 0 .325.12.442.335.117.214.183.505.183.808 0 .303-.066.593-.183.808-.117.214-.276.334-.442.334h-8.57A3.43 3.43 0 0 1 3.93 16.31Z",
  fill: "currentcolor"
}), 'Filter');

const Government = createSvgIcon(jsx("path", {
  d: "M21 10a1 1 0 0 0 1-1V6a.999.999 0 0 0-.684-.948l-9-3a1.002 1.002 0 0 0-.632 0l-9 3A.999.999 0 0 0 2 6v3a1 1 0 0 0 1 1h1v7.184A2.995 2.995 0 0 0 2 20v2a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a2.995 2.995 0 0 0-2-2.816V10h1Zm-1 11H4v-1a1.001 1.001 0 0 1 1-1h14a1.001 1.001 0 0 1 1 1v1ZM6 17v-7h2v7H6Zm4 0v-7h4v7h-4Zm6 0v-7h2v7h-2ZM4 8V6.72l8-2.666 8 2.667V8H4Z",
  fill: "currentcolor"
}), 'Government');

const Hamburger = createSvgIcon(jsx("path", {
  d: "M3.9 5h16.2M3.9 12h16.2M3.9 19h16.2",
  stroke: "#464D5D",
  strokeWidth: "2",
  strokeLinecap: "round"
}), 'Hamburger');

const HappyFace = createSvgIcon(jsx("path", {
  d: "M14.36 14.23a3.76 3.76 0 0 1-4.72 0 1.001 1.001 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1.001 1.001 0 0 0-1.28-1.54ZM9 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3-7a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z",
  fill: "currentcolor"
}), 'HappyFace');

const Health = createSvgIcon(jsx("path", {
  d: "M14 11h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Zm6.16-6A6.29 6.29 0 0 0 12 4.41a6.27 6.27 0 0 0-8.16 9.48l6 6.05a3 3 0 0 0 4.24 0l6-6.05A6.27 6.27 0 0 0 20.16 5Zm-1.41 7.46-6 6a1 1 0 0 1-1.42 0l-6-6a4.29 4.29 0 0 1 0-6 4.27 4.27 0 0 1 6 0 1 1 0 0 0 1.42 0 4.27 4.27 0 0 1 6 0 4.29 4.29 0 0 1 0 6.02v-.02Z",
  fill: "currentcolor"
}), 'Health');

const Home = createSvgIcon(jsx("path", {
  d: "m20 7.717-6-4.992A3.093 3.093 0 0 0 12 2c-.738 0-1.45.258-2 .725L4 7.717c-.318.27-.571.6-.743.97-.173.37-.26.77-.257 1.175v8.294c0 .755.316 1.48.879 2.013A3.084 3.084 0 0 0 6 21.003h12c.796 0 1.559-.3 2.121-.834A2.776 2.776 0 0 0 21 18.156V9.852a2.725 2.725 0 0 0-.259-1.17A2.859 2.859 0 0 0 20 7.718Zm-6 11.388h-4V14.36c0-.252.105-.493.293-.671.188-.178.442-.278.707-.278h2c.265 0 .52.1.707.278.188.178.293.42.293.67v4.746Zm5-.95a.925.925 0 0 1-.293.672 1.028 1.028 0 0 1-.707.278h-2V14.36c0-.755-.316-1.48-.879-2.013A3.084 3.084 0 0 0 13 11.513h-2c-.796 0-1.559.3-2.121.834A2.775 2.775 0 0 0 8 14.36v4.745H6c-.265 0-.52-.1-.707-.278A.925.925 0 0 1 5 18.156V9.852c0-.135.03-.268.09-.39a.954.954 0 0 1 .25-.322l6-4.982c.183-.152.417-.236.66-.236.243 0 .477.084.66.236l6 4.982a.955.955 0 0 1 .25.321.909.909 0 0 1 .09.391v8.304Z",
  fill: "currentcolor"
}), 'Home');

const Info = createSvgIcon(jsx("path", {
  d: "M12 11a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1Zm.38-3.92a1 1 0 0 0-.76 0 1 1 0 0 0-.33.21 1.15 1.15 0 0 0-.21.33 1 1 0 0 0 .21 1.09c.097.088.209.16.33.21A1 1 0 0 0 13 8a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-.33-.21ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z",
  fill: "currentcolor"
}), 'Info');

const Italics = createSvgIcon(jsx("path", {
  d: "M17 6h-6a1 1 0 1 0 0 2h1.52l-3.2 8H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-1.52l3.2-8H17a1 1 0 1 0 0-2Z",
  fill: "currentcolor"
}), 'Italics');

const Link = createSvgIcon(jsx("path", {
  d: "M11.168 14.785 8.043 17.91a2.03 2.03 0 0 1-2.82 0 1.99 1.99 0 0 1 0-2.819l3.126-3.125a.808.808 0 1 0-1.144-1.143L4.08 13.956a3.608 3.608 0 0 0 5.098 5.098l3.133-3.125a.81.81 0 0 0-1.143-1.144Zm6.91-9.729a3.616 3.616 0 0 0-5.098 0L9.847 8.181a.809.809 0 0 0 1.143 1.144L14.115 6.2a2.03 2.03 0 0 1 2.82 0 1.99 1.99 0 0 1 0 2.819l-3.126 3.124a.806.806 0 0 0 .262 1.32.805.805 0 0 0 .882-.176l3.125-3.133a3.616 3.616 0 0 0 0-5.098Zm-9.552 9.552a.805.805 0 0 0 .572.234.805.805 0 0 0 .572-.234l3.962-3.963a.809.809 0 1 0-1.143-1.143l-3.963 3.962a.804.804 0 0 0 0 1.144Z",
  fill: "currentcolor"
}), 'Link');

const Loading = createSvgIcon(jsx("path", {
  d: "M21 11a1 1 0 0 0-1 1 8.05 8.05 0 1 1-2.22-5.5h-2.4a1 1 0 1 0 0 2h4.53a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v1.77A10 10 0 1 0 22 12a1 1 0 0 0-1-1Z",
  fill: "currentcolor"
}), 'Loading');

const LocationPin = createSvgIcon(jsx("path", {
  d: "M12 2a8 8 0 0 0-8 8c0 5.4 7.05 11.5 7.35 11.76a1 1 0 0 0 1.3 0C13 21.5 20 15.4 20 10a8 8 0 0 0-8-8Zm0 17.65c-2.13-2-6-6.31-6-9.65a6 6 0 1 1 12 0c0 3.34-3.87 7.66-6 9.65ZM12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
  fill: "currentcolor"
}), 'LocationPin');

const Location = createSvgIcon(jsx("path", {
  d: "M12 2a8 8 0 0 0-8 8c0 5.4 7.05 11.5 7.35 11.76a1 1 0 0 0 1.3 0C13 21.5 20 15.4 20 10a8 8 0 0 0-8-8Zm0 17.65c-2.13-2-6-6.31-6-9.65a6 6 0 1 1 12 0c0 3.34-3.87 7.66-6 9.65ZM12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
  fill: "currentcolor"
}), 'Location');

const Lock = createSvgIcon(jsx("path", {
  d: "M12 13a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1Zm5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3ZM9 7a3 3 0 1 1 6 0v2H9V7Zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7Z",
  fill: "currentcolor"
}), 'Lock');

const Logout = createSvgIcon(jsx("path", {
  d: "m12.59 13-2.3 2.29a1 1 0 0 0 0 1.42 1.002 1.002 0 0 0 1.42 0l4-4c.091-.095.162-.207.21-.33a1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1.003 1.003 0 1 0-1.42 1.42l2.3 2.29H3a1 1 0 1 0 0 2h9.59ZM12 2a10 10 0 0 0-9 5.55 1.006 1.006 0 1 0 1.8.9A8 8 0 1 1 12 20a7.93 7.93 0 0 1-7.16-4.45 1.006 1.006 0 0 0-1.8.9A10 10 0 1 0 12 2Z",
  fill: "currentcolor"
}), 'Logout');

const MagicPencil = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "M21 7.716a.9.9 0 0 0-.261-.64l-3.816-3.815A.9.9 0 0 0 16.284 3a.9.9 0 0 0-.639.261l-2.547 2.547-9.837 9.836a.9.9 0 0 0-.261.639v3.816a.9.9 0 0 0 .9.9h3.816a.902.902 0 0 0 .684-.261l9.783-9.837L20.739 8.4a1.07 1.07 0 0 0 .198-.297.897.897 0 0 0 0-.216.631.631 0 0 0 0-.126L21 7.716ZM7.347 19.199H4.8v-2.547l8.937-8.936 2.547 2.546L7.347 19.2ZM17.553 8.994l-2.547-2.547 1.278-1.27 2.538 2.539-1.269 1.278ZM4.067 5.069a.5.5 0 0 1 .011-.92l1.79-.74a1 1 0 0 0 .54-.542l.69-1.663a.5.5 0 0 1 .933.025l.562 1.59a1 1 0 0 0 .579.598l1.867.729a.5.5 0 0 1 .011.927l-1.9.794a1 1 0 0 0-.555.58L8.03 8.004a.5.5 0 0 1-.93.025l-.694-1.63a1 1 0 0 0-.515-.522L4.067 5.07Zm-3 5.939a.5.5 0 0 1 .011-.919l.79-.327a1 1 0 0 0 .54-.541l.275-.663a.5.5 0 0 1 .933.025l.209.59a1 1 0 0 0 .579.597l.807.315a.5.5 0 0 1 .01.928l-.84.35a1 1 0 0 0-.553.581l-.213.584a.5.5 0 0 1-.93.025l-.28-.658a1 1 0 0 0-.515-.522l-.823-.365Zm14 7a.5.5 0 0 1 .011-.919l1.04-.43a1 1 0 0 0 .54-.542l.379-.913a.5.5 0 0 1 .933.025l.297.84a1 1 0 0 0 .579.598l1.072.418a.5.5 0 0 1 .011.928l-1.105.461a1 1 0 0 0-.555.58l-.3.827a.5.5 0 0 1-.93.026l-.384-.901a1 1 0 0 0-.515-.523l-1.073-.475Z"
  }), jsx("path", {
    fill: "currentcolor"
  })]
}), 'MagicPencil');

const MagnifyingGlass = createSvgIcon(jsx("path", {
  d: "M21.71 20.29 18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1.002 1.002 0 0 0 1.42 0 1 1 0 0 0 0-1.39ZM11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z",
  fill: "currentcolor"
}), 'MagnifyingGlass');

const Minimize = createSvgIcon(jsx("path", {
  d: "M5.8 11.225c-.442 0-.8.347-.8.775 0 .428.358.775.8.775h12.4c.442 0 .8-.347.8-.775a.788.788 0 0 0-.8-.775H5.8Z",
  fill: "currentcolor"
}), 'Minimize');

const MobileSms = createSvgIcon(jsx("path", {
  d: "m12.71 16.29-.15-.12a.762.762 0 0 0-.18-.09L12.2 16a1 1 0 0 0-.91.27 1.15 1.15 0 0 0-.21.33 1 1 0 0 0 1.3 1.31c.12-.058.23-.132.33-.22a.999.999 0 0 0 .21-1.09 1.001 1.001 0 0 0-.21-.31ZM16 2H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v14Z",
  fill: "currentcolor"
}), 'MobileSms');

const Mobile = createSvgIcon(jsx("path", {
  d: "m12.71 16.29-.15-.12a.762.762 0 0 0-.18-.09L12.2 16a1 1 0 0 0-.91.27 1.15 1.15 0 0 0-.21.33 1 1 0 0 0 1.3 1.31c.12-.058.23-.132.33-.22a.999.999 0 0 0 .21-1.09 1.001 1.001 0 0 0-.21-.31ZM16 2H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v14Z",
  fill: "currentcolor"
}), 'Mobile');

const NeutralFace = createSvgIcon(jsx("path", {
  d: "M9 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6 3H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm0-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3-7a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z",
  fill: "currentcolor"
}), 'NeutralFace');

const NoteActive = createSvgIcon(jsx("path", {
  d: "M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm-2-4H8a1 1 0 0 0 0 2h6c.265 0 .56-.105.747-.293.188-.187.253-.442.253-.707 0-.265-.066-.52-.253-.707A1.096 1.096 0 0 0 14 10Zm6-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v13Z",
  fill: "currentcolor"
}), 'NoteActive');

const Note = createSvgIcon(jsx("path", {
  d: "M20 4h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v13Z",
  fill: "currentcolor"
}), 'Note');

const Notifications = createSvgIcon(jsx("path", {
  d: "M18 13.18V10a6 6 0 0 0-5-5.91V3a1 1 0 0 0-2 0v1.09A6 6 0 0 0 6 10v3.18A3 3 0 0 0 4 16v2a1 1 0 0 0 1 1h3.14a4 4 0 0 0 7.72 0H19a1 1 0 0 0 1-1v-2a3 3 0 0 0-2-2.82ZM8 10a4 4 0 0 1 8 0v3H8v-3Zm4 10a2 2 0 0 1-1.72-1h3.44A2 2 0 0 1 12 20Zm6-3H6v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1Z",
  fill: "currentcolor"
}), 'Notifications');

const Paperclip = createSvgIcon(jsx("path", {
  d: "m18.1 12.4-6.2 6.2c-1.7 1.7-4.4 1.7-6 0-1.7-1.7-1.7-4.4 0-6l8-8c1-.9 2.5-.9 3.5 0 1 1 1 2.6 0 3.5L10.5 15c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l5.1-5.1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L8 12.6c-1.1 1.1-1.1 2.8 0 3.9 1.1 1 2.8 1 3.9 0l6.9-6.9c1.8-1.8 1.8-4.6 0-6.4-1.8-1.8-4.6-1.8-6.4 0l-8 8c-1.2 1.2-1.8 2.8-1.8 4.4 0 3.5 2.8 6.2 6.3 6.2 1.7 0 3.2-.7 4.4-1.8l6.2-6.2c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0Z",
  fill: "currentcolor"
}), 'Paperclip');

const Pen = createSvgIcon(jsx("path", {
  d: "M20.333 8.033a.833.833 0 0 0-.241-.591l-3.534-3.534a.834.834 0 0 0-.591-.241.833.833 0 0 0-.592.241l-2.358 2.359-9.109 9.108a.834.834 0 0 0-.241.592V19.5a.833.833 0 0 0 .833.833h3.533a.833.833 0 0 0 .634-.241l9.058-9.109 2.367-2.316a.991.991 0 0 0 .183-.275.836.836 0 0 0 0-.2.583.583 0 0 0 0-.117l.058-.042ZM7.692 18.667H5.333v-2.359l8.275-8.275 2.359 2.359-8.275 8.275Zm9.45-9.45-2.359-2.359 1.184-1.175 2.35 2.35-1.175 1.184Z",
  fill: "currentcolor"
}), 'Pen');

const Pencil = createSvgIcon(jsx("path", {
  d: "M5 18h4.24a1 1 0 0 0 .71-.29l6.92-6.93L19.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71V17a1 1 0 0 0 1 1Zm9.76-13.59 2.83 2.83-1.42 1.42-2.83-2.83 1.42-1.42ZM6 13.17l5.93-5.93 2.83 2.83L8.83 16H6v-2.83ZM21 20H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'Pencil');

const Phone = createSvgIcon(jsx("path", {
  d: "M19.44 13c-.22 0-.45-.07-.67-.12a9.443 9.443 0 0 1-1.31-.39 2 2 0 0 0-2.48 1l-.22.45a12.18 12.18 0 0 1-2.66-2 12.18 12.18 0 0 1-2-2.66l.42-.28a2 2 0 0 0 1-2.48 10.32 10.32 0 0 1-.39-1.31c-.05-.22-.09-.45-.12-.68a3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 2.741-1.778c.173-.387.261-.808.259-1.232v-3a3 3 0 0 0-2.47-2.9Zm.5 6a1 1 0 0 1-.723.963c-.142.043-.29.055-.437.037A17 17 0 0 1 4.07 5.22a1.09 1.09 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79 11.301 11.301 0 0 0 .61 2.36l-1.4.65a1 1 0 0 0-.49 1.33 14.49 14.49 0 0 0 7 7 1 1 0 0 0 .76 0 1 1 0 0 0 .57-.52l.62-1.4a13.59 13.59 0 0 0 1.58.46c.267.06.537.11.81.15a1 1 0 0 1 .79 1l.02 3.12Z",
  fill: "currentcolor"
}), 'Phone');

const Plane = createSvgIcon(jsx("path", {
  d: "M22.324 13.129 2.813 22.865c-.933.47-1.976-.36-1.757-1.383l1.172-5.685c.172-.838.258-1.257.475-1.582a2 2 0 0 1 .723-.655c.345-.183.77-.228 1.62-.316l9.841-1.028c.33-.028.33-.415 0-.443L5.02 10.745c-.85-.088-1.276-.133-1.62-.316a2.001 2.001 0 0 1-.724-.655c-.217-.325-.303-.744-.476-1.582L1.029 2.508c-.22-1.024.85-1.826 1.756-1.383l19.512 9.736c.933.47.933 1.798.027 2.268Z",
  fill: "currentcolor"
}), 'Plane');

const PlusCircle = createSvgIcon(jsx("path", {
  d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Zm4-9h-3V8a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'PlusCircle');

const PlusSync = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.95 5.305C11.7-1.392 21.9 3.21 21.9 11.76a.9.9 0 0 1-1.8 0c0-6.806-8.076-10.743-13.747-5.308l1.835.004a.9.9 0 1 1-.003 1.8l-4.158-.009a.9.9 0 0 1-.881-1.078.906.906 0 0 1-.01-.147l.034-3.984a.9.9 0 0 1 1.8.015l-.02 2.253Zm7.172 2.754a.9.9 0 0 1 .9.9v2.008h1.91a.9.9 0 0 1 0 1.8h-1.91v1.792a.9.9 0 0 1-1.8 0v-1.792H9.087a.9.9 0 0 1 0-1.8h2.135V8.959a.9.9 0 0 1 .9-.9ZM3 11.341a.9.9 0 0 1 .9.9c0 6.806 8.076 10.743 13.747 5.308l-1.835-.004a.9.9 0 0 1 .003-1.8l4.158.009a.9.9 0 0 1 .88 1.078.913.913 0 0 1 .012.147l-.035 3.984a.9.9 0 0 1-1.8-.015l.02-2.253C12.3 25.392 2.1 20.79 2.1 12.24a.9.9 0 0 1 .9-.9Z",
  fill: "currentcolor"
}), 'PlusSync');

const Plus = createSvgIcon(jsx("path", {
  d: "M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'Plus');

const PositionNew = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4.636c-.754 0-1.283.565-1.283 1.165 0 .599.53 1.164 1.282 1.164.753 0 1.282-.565 1.282-1.164 0-.6-.529-1.165-1.282-1.165ZM9.08 5.801C9.08 4.21 10.434 3 12 3c1.566 0 2.918 1.21 2.918 2.8a2.71 2.71 0 0 1-.643 1.756c.32.178.617.396.885.65a4.192 4.192 0 0 1 1.333 3.047v1.487a.818.818 0 0 1-.818.819h-.858l-.431 3.254a.818.818 0 0 1-.811.71h-3.15a.818.818 0 0 1-.811-.71l-.431-3.254h-.858a.818.818 0 0 1-.819-.819v-1.487c0-1.152.486-2.248 1.333-3.048.269-.253.566-.47.885-.649a2.705 2.705 0 0 1-.643-1.755ZM12 8.602a2.97 2.97 0 0 0-2.037.793 2.556 2.556 0 0 0-.82 1.858v.67H9.9c.41 0 .757.303.81.71l.432 3.254h1.716l.43-3.254a.82.82 0 0 1 .812-.71h.757v-.67c0-.687-.289-1.357-.82-1.858A2.971 2.971 0 0 0 12 8.602ZM8.824 16.65c.03.45-.311.84-.762.87-1.524.102-2.555.361-3.11.637a1.847 1.847 0 0 0-.202.115c.07.05.173.111.319.18.321.152.785.308 1.412.446 1.253.277 3.073.465 5.52.465 2.449 0 4.268-.188 5.52-.465.628-.138 1.091-.294 1.412-.446.144-.068.246-.13.317-.179a1.859 1.859 0 0 0-.204-.116c-.555-.275-1.587-.534-3.11-.636a.818.818 0 1 1 .108-1.632c1.612.107 2.892.387 3.73.803.408.203.812.487 1.042.895.271.48.235 1.016-.06 1.464-.255.386-.673.667-1.123.88-.467.221-1.056.41-1.759.565-1.406.31-3.353.504-5.872.504-2.52 0-4.466-.194-5.873-.504-.703-.155-1.293-.344-1.76-.565-.45-.213-.869-.494-1.124-.88a1.369 1.369 0 0 1-.063-1.463c.23-.409.634-.693 1.043-.896.836-.416 2.116-.696 3.728-.804.45-.03.84.311.87.762Z",
  fill: "currentcolor"
}), 'PositionNew');

const PositionNew2 = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.185 4.679c0-1.756 1.447-3.179 3.232-3.179h13.166c1.785 0 3.232 1.423 3.232 3.179v11.355c0 1.756-1.447 3.179-3.232 3.179h-3.647L11.933 22.5 8.93 19.213H5.417c-1.785 0-3.232-1.423-3.232-3.179V4.68Zm3.232-1.363c-.765 0-1.385.61-1.385 1.363v11.355c0 .026 0 .051.002.077 1.362-2.212 3.468-3.594 5.754-4.13a3.954 3.954 0 0 1-1.831-3.329c0-2.194 1.808-3.973 4.04-3.973 2.23 0 4.04 1.779 4.04 3.973 0 1.394-.73 2.62-1.834 3.329a9.162 9.162 0 0 1 5.76 4.165 1.38 1.38 0 0 0 .005-.112V4.68c0-.753-.62-1.363-1.385-1.363H5.417Zm0 14.08h-.003c2.758-5.037 10.11-5.18 13.047-.18l.106.18h-4.455l-2.18 2.386-2.179-2.386H5.417Zm8.772-8.744c0 1.192-.981 2.157-2.193 2.157-1.21 0-2.193-.965-2.193-2.157 0-1.191.982-2.157 2.193-2.157 1.212 0 2.193.966 2.193 2.157Z",
  fill: "currentcolor"
}), 'PositionNew2');

const Position = createSvgIcon(jsx("path", {
  d: "M14.81 12.28a3.73 3.73 0 0 0 1-2.5 3.78 3.78 0 1 0-7.56 0 3.73 3.73 0 0 0 1 2.5A5.94 5.94 0 0 0 6 16.89a1.006 1.006 0 1 0 2 .22 4 4 0 0 1 7.94 0A1 1 0 0 0 17 18h.11a1 1 0 0 0 .88-1.1 5.94 5.94 0 0 0-3.18-4.62ZM12 11.56A1.78 1.78 0 1 1 12 8a1.78 1.78 0 0 1 0 3.56ZM19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14Z",
  fill: "currentcolor"
}), 'Position');

const Preview = createSvgIcon(jsx("path", {
  d: "M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8ZM12 18c-3.18 0-6.17-2.29-7.9-6C5.83 8.29 8.82 6 12 6c3.18 0 6.17 2.29 7.9 6-1.73 3.71-4.72 6-7.9 6Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
  fill: "currentcolor"
}), 'Preview');

const Profile = createSvgIcon(jsx("path", {
  d: "M12 2a10 10 0 0 0-7.35 16.76 10.001 10.001 0 0 0 14.7 0A9.999 9.999 0 0 0 12 2Zm0 18a8 8 0 0 1-5.55-2.25 6 6 0 0 1 11.1 0A8 8 0 0 1 12 20Zm-2-10a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm8.91 6A8 8 0 0 0 15 12.62a4 4 0 1 0-6 0A8 8 0 0 0 5.09 16 7.92 7.92 0 0 1 4 12a8 8 0 1 1 16 0 7.92 7.92 0 0 1-1.09 4Z",
  fill: "currentcolor"
}), 'Profile');

const Puzzle = createSvgIcon(jsx("path", {
  d: "M17 22H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1a4 4 0 0 1 7.3-2.18c.448.64.692 1.4.7 2.18h3a1 1 0 0 1 1 1v3a4 4 0 0 1 2.18 7.3A3.86 3.86 0 0 1 18 18v3a1 1 0 0 1-1 1ZM5 8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11v-3.18a1 1 0 0 1 1.33-.95 1.77 1.77 0 0 0 1.74-.23 2 2 0 0 0 .93-1.37 2 2 0 0 0-.48-1.59 1.89 1.89 0 0 0-2.17-.55 1 1 0 0 1-1.33-.95V8h-3.2a1 1 0 0 1-1-1.33 1.77 1.77 0 0 0-.23-1.74 1.939 1.939 0 0 0-3-.43A2 2 0 0 0 8 6c.002.23.046.456.13.67A1 1 0 0 1 7.18 8H5Z",
  fill: "currentcolor"
}), 'Puzzle');

const QuestionInfo = createSvgIcon(jsx("path", {
  d: "M11.29 15.29a1.573 1.573 0 0 0-.12.15.762.762 0 0 0-.09.18.643.643 0 0 0-.06.18 1.362 1.362 0 0 0 0 .2.84.84 0 0 0 .08.38.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54A1 1 0 0 0 13 16a1 1 0 0 0-1.71-.71ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Zm0-13a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1A1 1 0 0 1 12 9a1 1 0 1 1 0 2 1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-.18A3 3 0 0 0 12 7Z",
  fill: "currentcolor"
}), 'QuestionInfo');

const Reapply = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.293 11.294a1 1 0 0 1 1.707.707 10 10 0 1 1-3.09-7.23v-1.77a1 1 0 0 1 2 0v4.5a1 1 0 0 1-1 1h-4.53a1 1 0 1 1 0-2h2.4a8.05 8.05 0 1 0 2.22 5.5 1 1 0 0 1 .293-.707Zm-5.127.23a3.308 3.308 0 0 1-.602 1.663c.46.285.87.646 1.213 1.068a1.069 1.069 0 0 1 .12 1.114 1.05 1.05 0 0 1-.38.436 1.021 1.021 0 0 1-1.357-.228 2.725 2.725 0 0 0-.943-.777 2.671 2.671 0 0 0-1.18-.28c-.41.001-.814.097-1.182.28-.367.183-.69.449-.943.777a1.075 1.075 0 0 1-.71.414 1.048 1.048 0 0 1-.787-.218 1.083 1.083 0 0 1-.406-.724 1.11 1.11 0 0 1 .214-.804c.328-.414.72-.771 1.16-1.058a3.324 3.324 0 0 1-.262-3.404 3.243 3.243 0 0 1 1.18-1.302 3.154 3.154 0 0 1 3.346 0c.503.315.912.766 1.18 1.303.268.537.385 1.139.339 1.74Zm-3.805.7a1.113 1.113 0 0 0 1.437-.16 1.157 1.157 0 0 0 .316-.843 1.169 1.169 0 0 0-.21-.629 1.133 1.133 0 0 0-.515-.405 1.108 1.108 0 0 0-1.217.276 1.173 1.173 0 0 0-.227 1.25c.087.208.232.386.416.51Z",
  fill: "currentcolor"
}), 'Reapply');

const Redo = createSvgIcon(jsx("path", {
  d: "M12.274 9.753c1.52 0 2.997.498 4.207 1.417l-2.043 2.042a.609.609 0 0 0 .433 1.04h5.278A.844.844 0 0 0 21 13.41V8.131a.61.61 0 0 0-1.04-.431l-1.876 1.875A9.247 9.247 0 0 0 3 16.503h2.25a7.034 7.034 0 0 1 7.024-6.75Z",
  fill: "currentcolor"
}), 'Redo');

const Report = createSvgIcon(jsx("path", {
  d: "M22 10.94a1.306 1.306 0 0 0-.06-.27v-.09a1.071 1.071 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19h-.1a1.099 1.099 0 0 0-.31-.11H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6.06Zm-6-3.53L18.59 10H17a1 1 0 0 1-1-1V7.41ZM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h9v3a3 3 0 0 0 3 3h3v5ZM7 12h4a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2Zm0 2a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H7Z",
  fill: "currentcolor"
}), 'Report');

const Reports = createSvgIcon(jsx("path", {
  d: "M18 19H6a3 3 0 0 1-3-3V8a1 1 0 0 0-2 0v8a5 5 0 0 0 5 5h12a1 1 0 0 0 0-2Zm-4-8h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm9-1.06a1.307 1.307 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19h-.09a.88.88 0 0 0-.33-.11H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V9.94Zm-6-3.53L19.59 9H18a1 1 0 0 1-1-1V6.41ZM21 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h7v3a3 3 0 0 0 3 3h3v3ZM10 9h2a1 1 0 1 0 0-2h-2a1 1 0 0 0 0 2Z",
  fill: "currentcolor"
}), 'Reports');

const SadFace = createSvgIcon(jsx("path", {
  d: "M8.36 15.33a1 1 0 0 0 .173 1.646.998.998 0 0 0 1.107-.116 3.76 3.76 0 0 1 4.72 0 1 1 0 0 0 .64.23 1 1 0 0 0 .64-1.76 5.81 5.81 0 0 0-7.28 0Zm.85-4.79a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41 3.08 3.08 0 0 0-4.24 0 1 1 0 1 0 1.41 1.41 1.001 1.001 0 0 1 1.42 0ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Zm5.62-10.87a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1.002 1.002 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41Z",
  fill: "currentcolor"
}), 'SadFace');

const Send = createSvgIcon(jsx("path", {
  d: "M23.263 13.232 1.978 23.852C.96 24.367-.178 23.46.062 22.345l1.32-6.412c.173-.838.26-1.257.476-1.581a2 2 0 0 1 .723-.655c.345-.184.77-.228 1.62-.317l10.949-1.143c.36-.03.36-.453 0-.483L4.173 10.609c-.852-.088-1.277-.133-1.622-.316a2 2 0 0 1-.723-.655c-.217-.325-.303-.744-.476-1.582L.032 1.645C-.208.528.96-.347 1.948.135l21.285 10.622c1.018.513 1.018 1.962.03 2.475Z",
  fill: "currentcolor"
}), 'Send');

const Settings = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.04 1.183c-.325.05-.637.16-.923.32-.279.157-.727.597-.89.872-.062.108-.249.54-.414.962-.1.26-.203.518-.309.775-.004.004-.372.215-.818.468-.547.31-.832.454-.88.442-.34-.078-1.482-.223-1.746-.222a2.503 2.503 0 0 0-1.89.89c-.224.273-.96 1.565-1.077 1.89-.085.234-.092.294-.093.778 0 .48.008.548.09.795.129.383.274.612.844 1.318l.501.621v1.819l-.308.39c-.758.958-.879 1.147-1.022 1.585-.062.192-.073.302-.073.733 0 .7.026.778.585 1.76.16.28.35.6.425.711.344.512.865.879 1.462 1.032.394.104.797.092 1.673-.046l.728-.116.803.46.802.459.159.41c.527 1.357.552 1.403.965 1.815.239.24.347.32.61.448.473.234.633.264 1.54.285.885.02 1.32-.016 1.68-.142.624-.216 1.205-.734 1.456-1.298.039-.087.189-.463.333-.835l.262-.678.807-.462.807-.463.727.117c.875.14 1.278.15 1.672.047.496-.13.942-.407 1.277-.796.231-.27.976-1.56 1.102-1.912.085-.235.092-.295.093-.779 0-.48-.008-.548-.09-.795-.129-.383-.274-.612-.844-1.318l-.501-.621v-1.82l.427-.54c.647-.822.763-1.008.903-1.433.062-.193.073-.303.073-.734 0-.7-.026-.778-.585-1.76-.16-.28-.35-.6-.424-.711a2.517 2.517 0 0 0-1.463-1.032c-.394-.104-.797-.092-1.673.046l-.728.115-.805-.46-.803-.46-.065-.17c-.332-.886-.57-1.438-.71-1.652A2.67 2.67 0 0 0 13.22 1.23c-.262-.066-1.799-.099-2.18-.047Zm1.786 2.043c.07.033.132.082.18.143.038.053.23.515.43 1.025.254.66.392.968.472 1.066.075.09.255.22.517.371 1.838 1.063 2.103 1.207 2.276 1.24.153.029.323.012 1.184-.12 1.102-.17 1.163-.168 1.333.01.1.105.675 1.094.74 1.272.087.24.074.262-.865 1.46-.273.35-.442.597-.476.7-.045.134-.05.376-.043 1.676.01 1.375.016 1.53.07 1.628.033.06.348.468.7.907.7.872.733.937.63 1.186-.111.265-.669 1.2-.765 1.28a.546.546 0 0 1-.194.104c-.053.012-.548-.047-1.108-.133-.881-.134-1.036-.149-1.187-.119-.124.026-.512.23-1.355.716-.436.246-.867.5-1.293.763-.18.135-.256.286-.598 1.172-.402 1.044-.425 1.089-.593 1.175-.122.062-.198.067-.864.067-.801 0-.902-.019-1.024-.19-.037-.053-.23-.515-.428-1.025-.255-.66-.393-.968-.473-1.066-.075-.09-.255-.22-.517-.371-1.838-1.063-2.103-1.207-2.276-1.24-.153-.029-.323-.012-1.184.12-1.102.17-1.163.168-1.333-.01-.1-.105-.675-1.095-.74-1.272-.086-.24-.073-.263.865-1.46.257-.328.442-.599.474-.692.078-.227.076-2.999-.001-3.227-.037-.106-.261-.415-.708-.973-.715-.893-.75-.956-.646-1.205.111-.265.669-1.2.765-1.28a.546.546 0 0 1 .194-.104c.053-.013.548.047 1.108.133.873.133 1.037.149 1.183.118.252-.051 2.554-1.356 2.763-1.565.143-.142.183-.224.52-1.097.202-.519.397-.987.434-1.04.121-.17.213-.188 1-.19.54 0 .748.01.833.047Zm-1.263 4.762c-1.47.164-2.768 1.152-3.303 2.513-.22.565-.27.85-.268 1.53.002.541.012.645.089.933.464 1.738 1.87 2.912 3.665 3.061.766.064 1.754-.194 2.425-.631a4.073 4.073 0 0 0 1.415-1.559c.793-1.551.497-3.463-.727-4.677a4.048 4.048 0 0 0-3.296-1.17Zm.86 2.045c.571.12 1.101.53 1.363 1.057.179.36.223.582.203 1.024-.012.288-.034.402-.11.594-.475 1.181-1.82 1.65-2.916 1.017a2.588 2.588 0 0 1-.402-.339c-.388-.398-.558-.825-.558-1.4 0-.588.16-.978.575-1.396.51-.514 1.14-.704 1.845-.556Z",
  fill: "currentcolor"
}), 'Settings');

const Shield = createSvgIcon(jsx("path", {
  d: "M19.63 3.65a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27A1 1 0 0 0 4 4.43v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78ZM18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39v6.3Zm-4.46-2.29-2.69 2.7-.89-.9a1.004 1.004 0 0 0-1.42 1.42l1.6 1.6a1.002 1.002 0 0 0 1.42 0L15 11a1.004 1.004 0 1 0-1.42-1.42l-.04.01Z",
  fill: "currentcolor"
}), 'Shield');

const Shop = createSvgIcon(jsx("path", {
  d: "M21.09 2.91H2.91a.91.91 0 0 0-.91.908v3.637a2.727 2.727 0 0 0 1.818 2.563v10.164a.909.909 0 0 0 .91.909h14.545a.91.91 0 0 0 .909-.91V10.019A2.727 2.727 0 0 0 22 7.455V3.818a.91.91 0 0 0-.91-.909Zm-6.363 1.817h1.819v2.728a.91.91 0 0 1-1.819 0V4.727Zm-3.636 0h1.818v2.728a.91.91 0 0 1-1.818 0V4.727Zm-3.636 0h1.818v2.728a.91.91 0 0 1-1.818 0V4.727ZM4.727 8.364a.91.91 0 0 1-.909-.91V4.728h1.818v2.728a.91.91 0 0 1-.909.909Zm9.091 10.909h-3.636v-3.637a1.818 1.818 0 0 1 3.636 0v3.637Zm4.546 0h-2.728v-3.637a3.636 3.636 0 0 0-7.272 0v3.637H5.636v-9.255c.335-.124.643-.309.91-.545a2.727 2.727 0 0 0 3.636 0 2.727 2.727 0 0 0 3.636 0 2.727 2.727 0 0 0 3.636 0c.267.236.575.421.91.545v9.255Zm1.818-11.818a.91.91 0 0 1-1.818 0V4.727h1.818v2.728Z",
  fill: "currentcolor"
}), 'Shop');

const SmallChevronDown = createSvgIcon(jsx("path", {
  d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1.001 1.001 0 0 0 1.42 0L17 10.59a.999.999 0 0 0 0-1.42Z",
  fill: "currentcolor"
}), 'SmallChevronDown');

const SmallChevronUp = createSvgIcon(jsx("path", {
  d: "m17 13.41-4.29-4.24a.999.999 0 0 0-1.42 0l-4.24 4.24a1 1 0 1 0 1.41 1.42L12 11.29l3.54 3.54a1 1 0 0 0 1.41 0 1 1 0 0 0 .05-1.42Z",
  fill: "currentcolor"
}), 'SmallChevronUp');

const SourcingTools = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.488 18.202A7.967 7.967 0 0 1 12 19a7.972 7.972 0 0 1-3.208-.67l.001-.012m-1.628-.944a8 8 0 1 1 9.913-.192 6.142 6.142 0 0 0-.621-1.354c-.489-.786-1.257-1.577-2.408-2.004a3.4 3.4 0 1 0-3.796 0c-1.152.427-1.92 1.218-2.408 2.004a6.195 6.195 0 0 0-.676 1.53l-.004.016Zm8.323.828a4.398 4.398 0 0 0-.56-1.424c-.462-.743-1.261-1.475-2.777-1.475-1.516 0-2.316.732-2.778 1.475a4.395 4.395 0 0 0-.577 1.522l-.003.017m7.716 1.61A9.958 9.958 0 0 1 12 21C6.477 21 2 16.523 2 11S6.477 1 12 1s10 4.477 10 10a9.984 9.984 0 0 1-3.967 7.976l1.955 2.704a.805.805 0 0 1-.247 1.188 1.006 1.006 0 0 1-1.302-.271l-1.93-2.67Zm-4.358-7.324a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Z",
  fill: "currentcolor"
}), 'SourcingTools');

const StarBorder = createSvgIcon(jsx("path", {
  d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 1.45 1.07L12 18.76l5.1 2.68c.14.08.299.12.46.12a1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67Zm-6.15 4a1 1 0 0 0-.29.89l.72 4.19-3.76-2a1 1 0 0 0-.94 0l-3.76 2 .72-4.19a1 1 0 0 0-.29-.89l-3-3 4.21-.61a1 1 0 0 0 .76-.55L12 5.7l1.88 3.82a1 1 0 0 0 .76.55l4.21.61-3 2.99Z",
  fill: "currentcolor"
}), 'StarBorder');

const StarNew = createSvgIcon(jsx("path", {
  d: "M22 10.1c.1-.5-.3-1.1-.8-1.1l-5.7-.8L12.9 3c-.1-.2-.2-.3-.4-.4-.5-.3-1.1-.1-1.4.4L8.6 8.2 2.9 9c-.3 0-.5.1-.6.3-.4.4-.4 1 0 1.4l4.1 4-1 5.7c0 .2 0 .4.1.6.3.5.9.7 1.4.4l5.1-2.7 5.1 2.7c.1.1.3.1.5.1h.2c.5-.1.9-.6.8-1.2l-1-5.7 4.1-4c.2-.1.3-.3.3-.5Z",
  fill: "currentcolor"
}), 'StarNew');

const Star = createSvgIcon(jsx("path", {
  d: "M22 9.67a1 1 0 0 0-.86-.67l-5.69-.83L12.9 3a1 1 0 0 0-1.8 0L8.55 8.16 2.86 9a1 1 0 0 0-.81.68 1 1 0 0 0 .25 1l4.13 4-1 5.68a1 1 0 0 0 1.47 1.08l5.1-2.67 5.1 2.67c.14.08.3.12.46.12a1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1l-1-5.68 4.13-4A1 1 0 0 0 22 9.67Zm-6.15 4a.997.997 0 0 0-.29.88l.72 4.2-3.76-2a1.061 1.061 0 0 0-.94 0l-3.76 2 .72-4.2a.999.999 0 0 0-.29-.88l-3-3 4.21-.61a1 1 0 0 0 .76-.55L12 5.7l1.88 3.82a1 1 0 0 0 .76.55l4.21.61-3 2.99Z",
  fill: "currentcolor"
}), 'Star');

const Sync = createSvgIcon(jsx("path", {
  d: "M19.91 15.51h-4.53a1 1 0 0 0 0 2h2.4A8 8 0 0 1 4 12a1 1 0 1 0-2 0 10 10 0 0 0 16.88 7.23V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-.97-.99ZM12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 0 1 20 12a1 1 0 0 0 2 0A10 10 0 0 0 12 2Z",
  fill: "currentcolor"
}), 'Sync');

const TagActive = createSvgIcon(jsxs(Fragment, {
  children: [jsx("path", {
    d: "M6.444 6.169A1 1 0 1 1 7.556 7.83a1 1 0 0 1-1.112-1.66ZM12.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "currentcolor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.23 2.32 9.48 9.46c.18.19.284.439.29.7a.998.998 0 0 1-.29.71L13.2 21.7a1 1 0 0 1-.71.29 1.05 1.05 0 0 1-.71-.29l-9.49-9.5a1.05 1.05 0 0 1-.29-.71v-6a1 1 0 0 1 .29-.71l2.5-2.49A1 1 0 0 1 5.5 2h6a1 1 0 0 1 .73.32ZM4 11.09l8.49 8.5 7.09-7.1L11.08 4H5.9L4 5.9v5.19Z",
    fill: "currentcolor"
  })]
}), 'TagActive');

const Tag = createSvgIcon(jsx("path", {
  d: "M7 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm14.71 5.78-9.48-9.46A1 1 0 0 0 11.5 2h-6a1 1 0 0 0-.71.29l-2.5 2.49a1 1 0 0 0-.29.71v6c.004.265.107.518.29.71l9.49 9.5c.192.183.445.286.71.29a1.002 1.002 0 0 0 .71-.29l8.51-8.51a1.001 1.001 0 0 0 .29-.71 1.05 1.05 0 0 0-.29-.7Zm-9.22 7.81L4 11.09V5.9L5.9 4h5.18l8.5 8.49-7.09 7.1Z",
  fill: "currentcolor"
}), 'Tag');

const TaxEntity = createSvgIcon(jsx("path", {
  d: "M9.5 10.5H12a1 1 0 1 0 0-2h-1V8a1 1 0 1 0-2 0v.55a2.5 2.5 0 0 0 .5 4.95h1a.5.5 0 0 1 0 1H8a1 1 0 0 0 0 2h1v.5a1 1 0 1 0 2 0v-.55a2.5 2.5 0 0 0-.5-4.95h-1a.5.5 0 0 1 0-1ZM21 12h-3V3a1 1 0 0 0-1.5-.87l-3 1.72-3-1.72a1 1 0 0 0-1 0l-3 1.72-3-1.72A1 1 0 0 0 2 3v16a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1ZM5 20a1 1 0 0 1-1-1V4.73l2 1.14a1.08 1.08 0 0 0 1 0l3-1.72 3 1.72a1.08 1.08 0 0 0 1 0l2-1.14V19a3 3 0 0 0 .18 1H5Zm15-1a1 1 0 1 1-2 0v-5h2v5Z",
  fill: "currentcolor"
}), 'TaxEntity');

const ThumbsDown = createSvgIcon(jsx("path", {
  d: "M19 2H6.27a3 3 0 0 0-2.95 2.46l-1.27 7A3 3 0 0 0 5 15h4.56L9 16.43A4.13 4.13 0 0 0 12.89 22a1 1 0 0 0 .91-.59L16.65 15H19a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm-4 11.79-2.72 6.12a2.13 2.13 0 0 1-1.38-2.78l.53-1.43A2 2 0 0 0 9.56 13H5a1 1 0 0 1-.77-.36 1 1 0 0 1-.23-.82l1.27-7a1 1 0 0 1 1-.82H15v9.79ZM20 12a1 1 0 0 1-1 1h-2V4h2a1 1 0 0 1 1 1v7Z",
  fill: "currentcolor"
}), 'ThumbsDown');

const ThumbsUp = createSvgIcon(jsx("path", {
  d: "M21.3 10.08A3 3 0 0 0 19 9h-4.56L15 7.57A4.13 4.13 0 0 0 11.11 2a1 1 0 0 0-.91.59L7.35 9H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12.73a3 3 0 0 0 2.95-2.46l1.27-7a3 3 0 0 0-.65-2.46ZM7 20H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2v9Zm13-7.82-1.27 7a1 1 0 0 1-1 .82H9v-9.79l2.72-6.12a2.11 2.11 0 0 1 1.38 2.78l-.53 1.43a2 2 0 0 0 1.87 2.7H19a1 1 0 0 1 .77.36 1.002 1.002 0 0 1 .23.82Z",
  fill: "currentcolor"
}), 'ThumbsUp');

const TrashOutline = createSvgIcon(jsx("path", {
  d: "M10 18a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1ZM20 6h-4V5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H4a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8h1a1 1 0 1 0 0-2ZM10 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4V5Zm7 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8h10v11Zm-3-1a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1Z",
  fill: "currentcolor"
}), 'TrashOutline');

const Trash = createSvgIcon(jsx("path", {
  d: "M10 18a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1ZM20 6h-4V5a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H4a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8h1a1 1 0 1 0 0-2ZM10 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4V5Zm7 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8h10v11Zm-3-1a1 1 0 0 0 1-1v-6a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1Z",
  fill: "currentcolor"
}), 'Trash');

const Underline = createSvgIcon(jsx("path", {
  d: "M12 15.5a5 5 0 0 0 5-5v-5a1 1 0 0 0-2 0v5a3 3 0 0 1-6 0v-5a1 1 0 0 0-2 0v5a5 5 0 0 0 5 5Zm5 2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z",
  fill: "currentcolor"
}), 'Underline');

const Undo = createSvgIcon(jsx("path", {
  d: "M11.726 9.753c-1.52 0-2.997.498-4.207 1.417l2.043 2.042a.61.61 0 0 1-.433 1.04H3.851A.844.844 0 0 1 3 13.41V8.131A.61.61 0 0 1 4.04 7.7l1.876 1.875A9.247 9.247 0 0 1 21 16.503h-2.25a7.034 7.034 0 0 0-7.024-6.75Z",
  fill: "currentcolor"
}), 'Undo');

const Upload = createSvgIcon(jsx("path", {
  d: "M18.42 8.22a7 7 0 0 0-13.36 1.89A4 4 0 0 0 6 18a1 1 0 0 0 0-2 2 2 0 1 1 0-4 1 1 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1 1 0 0 0 .78.67 3 3 0 0 1 .24 5.84 1.002 1.002 0 0 0 .5 1.94 5 5 0 0 0 .17-9.62Zm-5.71 2.07a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1.001 1.001 0 0 0-.33.21l-3 3a1.004 1.004 0 0 0 1.42 1.42l1.29-1.3V19a1 1 0 0 0 2 0v-5.59l1.29 1.3a1.002 1.002 0 0 0 1.639-.326 1 1 0 0 0-.219-1.094l-3-3Z",
  fill: "currentcolor"
}), 'Upload');

const UserAdd = createSvgIcon(jsx("path", {
  d: "M21 10.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Zm-7.7 1.72A4.92 4.92 0 0 0 15 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 2 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28ZM10 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z",
  fill: "currentcolor"
}), 'UserAdd');

const UserCheck = createSvgIcon(jsx("path", {
  d: "M13.632 12.476a5.065 5.065 0 0 0 1.75-3.829 5.147 5.147 0 0 0-10.294 0 5.064 5.064 0 0 0 1.75 3.83A8.236 8.236 0 0 0 2 19.97a1.03 1.03 0 0 0 2.059 0 6.176 6.176 0 0 1 12.353 0 1.03 1.03 0 1 0 2.059 0 8.235 8.235 0 0 0-4.839-7.495Zm-3.397-.74a3.088 3.088 0 1 1 0-6.176 3.088 3.088 0 0 1 0 6.175Zm12.055-2.44a1.029 1.029 0 0 0-1.462 0l-2.059 2.058-.638-.648a1.029 1.029 0 0 0-1.761.726c0 .272.107.532.3.725l1.378 1.38a1.03 1.03 0 0 0 1.452 0l2.748-2.749a1.028 1.028 0 0 0 .042-1.492Z",
  fill: "currentcolor"
}), 'UserCheck');

const UserEntity = createSvgIcon(jsx("path", {
  d: "M14.81 12.28a3.73 3.73 0 0 0 1-2.5 3.78 3.78 0 1 0-7.56 0 3.73 3.73 0 0 0 1 2.5A5.94 5.94 0 0 0 6 16.89a1.006 1.006 0 1 0 2 .22 4 4 0 0 1 7.94 0A1 1 0 0 0 17 18h.11a1 1 0 0 0 .88-1.1 5.94 5.94 0 0 0-3.18-4.62ZM12 11.56A1.78 1.78 0 1 1 12 8a1.78 1.78 0 0 1 0 3.56ZM19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14Z",
  fill: "currentcolor"
}), 'UserEntity');

const User = createSvgIcon(jsx("path", {
  d: "M15.71 12.71a6 6 0 1 0-7.42 0 10 10 0 0 0-6.22 8.18 1.006 1.006 0 1 0 2 .22 8 8 0 0 1 15.9 0 1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1 10 10 0 0 0-6.25-8.19ZM12 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z",
  fill: "currentcolor"
}), 'User');

const Users = createSvgIcon(jsx("path", {
  d: "M12.3 12.22A4.92 4.92 0 0 0 14 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 1 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28ZM9 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm9.74.32A5 5 0 0 0 15 3.5a1 1 0 1 0 0 2 3 3 0 0 1 3 3 3 3 0 0 1-1.5 2.59 1 1 0 0 0-.05 1.7l.39.26.13.07a7 7 0 0 1 4 6.38 1 1 0 0 0 2 0 9 9 0 0 0-4.23-7.68Z",
  fill: "currentcolor"
}), 'Users');

const Warning = createSvgIcon(jsx("path", {
  d: "M12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10.67 1.47-8.05-14a3 3 0 0 0-5.24 0l-8 14A3 3 0 0 0 3.94 22h16.12a3 3 0 0 0 2.61-4.53Zm-1.73 2a1.001 1.001 0 0 1-.88.51H3.94a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02v-.02ZM12 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1Z",
  fill: "currentcolor"
}), 'Warning');

const WorkstreamLogo = createSvgIcon(jsx("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.144 8.732c-1.006.106-2.033.617-3.086 1.656a.915.915 0 0 1-1.286-1.302c1.263-1.248 2.658-2.014 4.18-2.174 1.523-.16 3.046.299 4.542 1.258 1.245.798 2.357 1.084 3.362.978 1.006-.105 2.033-.616 3.086-1.656a.915.915 0 0 1 1.286 1.302c-1.264 1.249-2.658 2.015-4.18 2.175-1.523.16-3.046-.3-4.542-1.258-1.245-.799-2.357-1.085-3.362-.979Zm0 6.12c-1.006.105-2.033.616-3.086 1.656a.915.915 0 0 1-1.286-1.302c1.263-1.249 2.658-2.015 4.18-2.175 1.523-.16 3.046.3 4.542 1.258 1.245.799 2.357 1.085 3.362.979 1.006-.106 2.033-.617 3.086-1.656a.915.915 0 1 1 1.286 1.302c-1.264 1.248-2.658 2.014-4.18 2.174-1.523.16-3.046-.3-4.542-1.258-1.245-.798-2.357-1.084-3.362-.978Z",
  fill: "currentcolor"
}), 'WorkstreamLogo');

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	ActiveChat: ActiveChat,
	ActiveDoubleChat: ActiveDoubleChat,
	ActiveNote: ActiveNote,
	ActiveTag: ActiveTag,
	AddUser: AddUser,
	Analysis: Analysis,
	ApplicantsAssistants: ApplicantsAssistants,
	ArrowCircle: ArrowCircle,
	ArrowDown: ArrowDown,
	ArrowLeftNew: ArrowLeftNew,
	ArrowLeft: ArrowLeft,
	ArrowRight: ArrowRight,
	ArrowUp: ArrowUp,
	ArrowsCollapse: ArrowsCollapse,
	ArrowsExpand: ArrowsExpand,
	Badge: Badge,
	Bag: Bag,
	Bell: Bell,
	Blocked: Blocked,
	Bold: Bold,
	BrokenChain: BrokenChain,
	Brush: Brush,
	CalendarNew: CalendarNew,
	Calendar: Calendar,
	ChatActive: ChatActive,
	ChatNew: ChatNew,
	Chat: Chat,
	ChatInactive: ChatInactive,
	CheckmarkCircle: CheckmarkCircle,
	CheckmarkSync: CheckmarkSync,
	Checkmark: Checkmark,
	ChevronDown: ChevronDown,
	ChevronLeft: ChevronLeft,
	ChevronRight: ChevronRight,
	ChevronUp: ChevronUp,
	CircleCross: CircleCross,
	CirclePlus: CirclePlus,
	Circle: Circle,
	ClipboardAlt: ClipboardAlt,
	Clipboard: Clipboard,
	Clock: Clock,
	CloudDownload: CloudDownload,
	Collapse: Collapse,
	Company: Company,
	ComposeMessage: ComposeMessage,
	Compose: Compose,
	ContactCard: ContactCard,
	Copy: Copy,
	CrossCircle: CrossCircle,
	Cross: Cross,
	Crown: Crown,
	DataChevronDown: DataChevronDown,
	DataChevronUp: DataChevronUp,
	DepartmentsNew: DepartmentsNew,
	Departments: Departments,
	DocumentAdd: DocumentAdd,
	DocumentApprove: DocumentApprove,
	DocumentExport: DocumentExport,
	DocumentSearch: DocumentSearch,
	Document: Document,
	DollarCircle: DollarCircle,
	DoubleChatActive: DoubleChatActive,
	DoubleChat: DoubleChat,
	DoubleChevronLeft: DoubleChevronLeft,
	DoubleChevronRight: DoubleChevronRight,
	Download: Download,
	Drag: Drag,
	Draggable: Draggable,
	Ellipses: Ellipses,
	Email: Email,
	Envelope: Envelope,
	ErrorNew: ErrorNew,
	Error: Error$1,
	Exit: Exit,
	Expand: Expand,
	ExternalLink: ExternalLink,
	Eye: Eye,
	FavoriteFile: FavoriteFile,
	Favorite: Favorite,
	Filter: Filter,
	Government: Government,
	Hamburger: Hamburger,
	HappyFace: HappyFace,
	Health: Health,
	Home: Home,
	Info: Info,
	Italics: Italics,
	Link: Link,
	Loading: Loading,
	LocationPin: LocationPin,
	Location: Location,
	Lock: Lock,
	Logout: Logout,
	MagicPencil: MagicPencil,
	MagnifyingGlass: MagnifyingGlass,
	Minimize: Minimize,
	MobileSms: MobileSms,
	Mobile: Mobile,
	NeutralFace: NeutralFace,
	NoteActive: NoteActive,
	Note: Note,
	Notifications: Notifications,
	Paperclip: Paperclip,
	Pen: Pen,
	Pencil: Pencil,
	Phone: Phone,
	Plane: Plane,
	PlusCircle: PlusCircle,
	PlusSync: PlusSync,
	Plus: Plus,
	PositionNew: PositionNew,
	PositionNew2: PositionNew2,
	Position: Position,
	Preview: Preview,
	Profile: Profile,
	Puzzle: Puzzle,
	QuestionInfo: QuestionInfo,
	Reapply: Reapply,
	Redo: Redo,
	Report: Report,
	Reports: Reports,
	SadFace: SadFace,
	Send: Send,
	Settings: Settings,
	Shield: Shield,
	Shop: Shop,
	SmallChevronDown: SmallChevronDown,
	SmallChevronUp: SmallChevronUp,
	SourcingTools: SourcingTools,
	StarBorder: StarBorder,
	StarNew: StarNew,
	Star: Star,
	Sync: Sync,
	TagActive: TagActive,
	Tag: Tag,
	TaxEntity: TaxEntity,
	ThumbsDown: ThumbsDown,
	ThumbsUp: ThumbsUp,
	TrashOutline: TrashOutline,
	Trash: Trash,
	Underline: Underline,
	Undo: Undo,
	Upload: Upload,
	UserAdd: UserAdd,
	UserCheck: UserCheck,
	UserEntity: UserEntity,
	User: User,
	Users: Users,
	Warning: Warning,
	WorkstreamLogo: WorkstreamLogo
});

export { ActiveChat, ActiveDoubleChat, ActiveNote, ActiveTag, AddUser, Analysis, ApplicantsAssistants, ArrowCircle, ArrowDown, ArrowLeft, ArrowLeftNew, ArrowRight, ArrowUp, ArrowsCollapse, ArrowsExpand, Badge, Bag, Bell, Blocked, Bold, BrokenChain, Brush, Calendar, CalendarNew, Chat, ChatActive, ChatInactive, ChatNew, Checkmark, CheckmarkCircle, CheckmarkSync, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Circle, CircleCross, CirclePlus, Clipboard, ClipboardAlt, Clock, CloudDownload, Collapse, Company, Compose, ComposeMessage, ContactCard, Copy, Cross, CrossCircle, Crown, DataChevronDown, DataChevronUp, Departments, DepartmentsNew, Document, DocumentAdd, DocumentApprove, DocumentExport, DocumentSearch, DollarCircle, DoubleChat, DoubleChatActive, DoubleChevronLeft, DoubleChevronRight, Download, Drag, Draggable, Ellipses, Email, Envelope, Error$1 as Error, ErrorNew, Exit, Expand, ExternalLink, Eye, Favorite, FavoriteFile, Filter, Government, Hamburger, HappyFace, Health, Home, Info, Italics, Link, Loading, Location, LocationPin, Lock, Logout, MagicPencil, MagnifyingGlass, Minimize, Mobile, MobileSms, NeutralFace, Note, NoteActive, Notifications, Paperclip, Pen, Pencil, Phone, Plane, Plus, PlusCircle, PlusSync, Position, PositionNew, PositionNew2, Preview, Profile, Puzzle, QuestionInfo, Reapply, Redo, Report, Reports, SadFace, Send, Settings, Shield, Shop, SmallChevronDown, SmallChevronUp, SourcingTools, Star, StarBorder, StarNew, Sync, Tag, TagActive, TaxEntity, ThumbsDown, ThumbsUp, Trash, TrashOutline, Underline, Undo, Upload, User, UserAdd, UserCheck, UserEntity, Users, Warning, WorkstreamLogo, WsIcon, createSvgIcon, index as iconByName };
